/* ============================================================
   EVAMATS — CRO overlay (config template, desktop + mobile)
   Zasada: ZERO zmian w logice konfiguratora (product-config.js /
   product.js / product-form.js). Ten plik tylko:
   - ujawnia Liquid chrome ([data-evm-chrome]) + klasę scope,
   - proxy'uje kliki do istniejących przycisków,
   - czyta stan (klasy .open/.complete, wartości inputów).
   ============================================================ */
(function () {
  'use strict';

  var EVM_CRO_SCRIPT_SRC = document.currentScript && document.currentScript.src;

  var EVM_EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;

  function tr(pl, en) { return EVM_EN ? en : pl; }
  function enValue(value) {
    var raw = String(value == null ? '' : value).trim();
    if (!EVM_EN || !raw) return raw;
    var key = raw.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[łŁ]/g, 'l').toLowerCase();
    var map = {
      'romby': 'Diamonds', 'plaster miodu': 'Honeycomb', 'krople': 'Droplets',
      'czarny': 'Black', 'brazowy': 'Brown', 'ciemnoszary': 'Dark Grey',
      'granatowy': 'Navy Blue', 'niebieski': 'Blue', 'zielony': 'Green',
      'czerwony': 'Red', 'bordowy': 'Maroon', 'jasnobezowy': 'Light Beige',
      'bezowy': 'Beige', 'fioletowy': 'Purple', 'jasnozielony': 'Light Green',
      'zolty': 'Yellow', 'pomaranczowy': 'Orange', 'kosc sloniowa': 'Ivory',
      'rozowy': 'Pink', 'bialy': 'White', 'jasnoszary': 'Light Grey',
      'malinowy': 'Raspberry', 'miedziany': 'Copper',
      'przod': 'Front', 'tyl': 'Rear', 'przod + tyl': 'Front + rear',
      'mata do bagaznika': 'Boot mat', 'dywanik kierowcy': "Driver's mat",
      '3d bez rantow': '3D without raised edges', '3d z rantami': '3D with raised edges',
      '3d z jezorem': '3D with tongue', 'nie wybrano': 'Not selected',
      'opcjonalnie': 'Optional', 'samochod': 'Vehicle', 'wariant': 'Variant',
      'ksztalt komorek': 'Cell pattern', 'kolory (material / obszycie)': 'Colours (mat / trim)',
      'podpietka': 'Heel pad', 'podpietki': 'Heel pads', 'akcesorium': 'Accessory',
      'dodatkowe opcje': 'Extras', 'pozycja': 'Item'
    };
    return map[key] || raw;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var product = document.querySelector('.product.config_container');
    if (!product) return;
    var info = product.querySelector('.product__info-container');
    if (!info) return;
    /* GUARD: uruchamiamy TYLKO na konfiguratorze dywaników (mat). Produkty na szablonie „config"
       bez pól mat (organizery, body_type „corners"/pusty, itp.) pomijamy, żeby ich NIE zepsuć. */
    if (!product.querySelector('fieldset[data-name="mats_set"], [data-dropdown="mats_set_type"], #rok-produkcji, [data-dropdown="year"]')) return;

    Array.prototype.slice.call(document.querySelectorAll('[data-evm-chrome][hidden]')).forEach(function (n) {
      if (n.classList.contains('evm-year-hint')) return;
      if (n.classList.contains('evm-summary')) return;
      n.removeAttribute('hidden');
    });
    document.documentElement.classList.add('evm-cro');
    var productHandleMatch = (window.location.pathname || '').match(/\/products\/([^\/?#]+)/);
    var currentProductHandle = productHandleMatch ? decodeURIComponent(productHandleMatch[1]) : '';
    var isIndividualPrepaymentProduct = currentProductHandle === 'zamowienie-indywidualne';

    /* ---------- helpers ---------- */
    function el(tag, cls, html) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (html != null) e.innerHTML = html;
      return e;
    }
    function evmAssetBase() {
      var source = EVM_CRO_SCRIPT_SRC || (Array.prototype.slice.call(document.scripts).find(function (s) {
        return /evm-cro-mobile\.js/.test(s.src || '');
      }) || {}).src;
      return source ? source.slice(0, source.lastIndexOf('/') + 1) : '/cdn/shop/assets/';
    }
    function assetUrl(file) {
      return evmAssetBase() + file;
    }
    function iconImg(file, alt) {
      return '<img class="evm-icon-img" width="84" height="84" decoding="async" alt="' + (alt || '') + '" src="' + assetUrl(file) + '">';
    }
    var ICONS = {
      car: iconImg('evm-icon-selected-vehicle.webp', ''),
      chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>',
      factory: iconImg('evm-icon-polish-production.webp', ''),
      factory10: iconImg('evm-icon-production-10-days.webp', ''),
      target: iconImg('evm-icon-car-model.webp', ''),
      /* wlasne ikony wierszy podsumowania — wczesniej pozyczaliśmy tu znaczek
         „Pod model auta” i rysowany szescian, przez co wygladalo to na blad ladowania */
      heelPad: iconImg('evm-icon-podpietki.webp', ''),
      extrasBox: iconImg('evm-icon-dodatki.webp', ''),
      drop: iconImg('evm-icon-water-dirt.webp', ''),
      pencil: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h4l10-10-4-4L4 16z"/><path d="M13.5 6.5l4 4"/></svg>',
      truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 7.5h10v8h-10z"/><path d="M13.5 10h3.4l3.6 3.2v2.3h-7z"/><path d="M5.7 17.5a2 2 0 1 0 4 0 2 2 0 0 0-4 0z"/><path d="M15.4 17.5a2 2 0 1 0 4 0 2 2 0 0 0-4 0z"/><path d="M3.5 11h5.2"/></svg>',
      delivery4: iconImg('evm-icon-delivery-4-days.webp', ''),
      check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8.5"/><path d="M8 12.3l2.5 2.5L16.5 9"/></svg>',
      box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7l9-4 9 4z"/><path d="M3 7v10l9 4 9-4V7"/><path d="M12 11v10"/></svg>'
    };
    function parsePLN(txt) {
      if (!txt) return 0;
      var m = String(txt).replace(/\s|&nbsp;/g, '').match(/(\d+(?:[.,]\d+)?)/);
      return m ? parseFloat(m[1].replace(',', '.')) : 0;
    }

    /* ---------- 1. pasek pojazdu + plakietki ---------- */
    var titleEl = product.querySelector('.product__title h1, h1.product__title, .product__title');
    var rawTitle = titleEl ? (titleEl.textContent || '').trim() : '';
    var vbar = product.querySelector('.evm-vehicle') || document.querySelector('.evm-vehicle');
    var renderedVehicle = vbar && vbar.querySelector('.evm-vehicle__name');
    var renderedYears = renderedVehicle && renderedVehicle.querySelector('.evm-vehicle__years');
    var renderedName = renderedVehicle && renderedVehicle.firstChild ? renderedVehicle.firstChild.textContent.trim().replace(/\u00a0/g, ' ') : '';
    function toRoman(n) {
      var m = ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];
      return m[n] || ('' + n);
    }
    function parseVehicle(t) {
      var s = t.replace(/^.*?\bdo\s+/i, '').trim();
      s = s.replace(/^(EVA\s+)?Dywaniki\b.*?\bdo\s+/i, '').trim();
      var gm = s.match(/^(.+?)\s+(\d{1,2})\s*gen(?:eracja|eracji)?\b/i);
      if (gm) return gm[1].trim().replace(/\s+/g, ' ') + ' ' + toRoman(parseInt(gm[2], 10)) + ' gen';
      // 28.09.2026: generacja zapisana rzymsko („Golf(MK4) IV gen”) — dotąd zostawała sama „Volkswagen Golf”. Kod nadwozia
      // w nawiasie zostaje jak w pozostałych kartach („Rav 4 (XA30) III gen”), tylko ze spacją: „Volkswagen Golf (MK4) IV gen”
      var gr = s.match(/^(.+?)\s+([IVX]{1,5})\s*gen(?:eracja|eracji)?\b/);
      if (gr) return gr[1].replace(/\s*\(/g, ' (').trim().replace(/\s+/g, ' ') + ' ' + gr[2] + ' gen';
      var base = s
        .replace(/\s*[\(\[].*$/, '')
        .replace(/\s+\d{4}\s*[-–—]\s*\d{2,4}.*$/, '')
        .replace(/\s+\d{4}\+?.*$/, '')
        .replace(/\s+rok\b.*$/i, '')
        .replace(/\s+(SUV|Sedan|Hatchback|Kombi|Coupe|Cabrio|Kabriolet|Roadster|Van|Minivan|Pickup|Bus|Liftback|Fastback|Crossover)\b.*$/i, '')
        .replace(/\s+\d+[-\s]?(drzwiowy|osobowy)\b.*$/i, '')
        .trim();
      return base || s;
    }
    // Liquid is authoritative for the selected-car card. Parse titles only where that card is absent.
    var vehicle = renderedName && !/^EVA\s+Dywaniki/i.test(renderedName) ? renderedName : parseVehicle(rawTitle) || rawTitle;
    var ym = rawTitle.match(/(\d{4})\s*[-–—]\s*(\d{4})/);
    var yearRange = renderedYears ? renderedYears.textContent.trim() : ym ? ym[1] + '–' + ym[2] : '';
    var cleanTitle = 'EVA Dywaniki 3D ' + vehicle + (yearRange ? ' ' + yearRange : '');
    Array.prototype.slice.call(product.querySelectorAll('h1')).forEach(function (h) {
      /* 14.10.2026: serwer (snippets/evm-vehicle-info.liquid) już wypisuje krótki nagłówek „EVA Dywaniki 3D …”;
         skrypt dopisuje go tylko tam, gdzie serwer go nie dał (np. wersja EN) */
      if (/Dywanik/i.test(h.textContent || '') && !/^EVA Dywaniki 3D /.test((h.textContent || '').trim())) h.textContent = cleanTitle;
    });

    function changeVehicle(event) {
      sessionStorage.setItem('evmReturnSummary', '1');
      if (event && event.currentTarget && event.currentTarget.tagName === 'A') return;
      var vehicleLink = product.querySelector('.evm-vehicle__change[href]');
      window.location.href = vehicleLink ? vehicleLink.href : '/collections';
    }

    var perks = product.querySelector('.evm-perks') || document.querySelector('.evm-perks');
    var vbars = Array.prototype.slice.call(product.querySelectorAll('.evm-vehicle'));
    vbars.forEach(function (bar) {
      var vChange = bar.querySelector('.evm-vehicle__change');
      if (vChange) {
        vChange.setAttribute('data-evm-brand-url', vChange.getAttribute('href') || '/collections');
        vChange.addEventListener('click', changeVehicle);
      }
    });
    /* Layout is Liquid-first (title-card / vehicle / perks / process). No DOM creates. */

    /* ---------- 2. sticky tabs ---------- */
    function findSection(sel) {
      var n = document.querySelector(sel);
      return n ? (n.closest('.shopify-section') || n) : null;
    }
    var tabTargetMap = {
      config: { target: product, tabId: null },
      description: { target: findSection('.product_tabs'), tabId: 'description' },
      tech: { target: findSection('.product_tabs'), tabId: 'tech' },
      delivery: { target: findSection('.product_tabs'), tabId: 'delivery' },
      faq: { target: findSection('.product_tabs'), tabId: 'faq' },
      cechy: { target: findSection('.image-with-text'), tabId: null },
      akcesoria: { target: findSection('.related-products-custom, [class*="related-products-custom"]'), tabId: null },
      opinie: { target: findSection('[class*="reputon"], [class*="google-review"], [class*="google_review"], .google-reviews, [data-google-reviews]'), tabId: null }
    };
    var tabsBar = product.querySelector('.evm-tabs') || document.querySelector('.evm-tabs');
    var tabsDef = [];
    var spyLock = false, spyLockT = null, activeIdx = 0;

    function prefersReduced() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    function setActive(idx) {
      if (idx == null || idx < 0) return;
      activeIdx = idx;
      tabsDef.forEach(function (t, i) {
        if (t.btn) t.btn.classList.toggle('active', i === idx);
      });
      var act = tabsDef[idx] && tabsDef[idx].btn;
      if (act && tabsBar) tabsBar.scrollTo({ left: Math.max(0, act.offsetLeft - 40), behavior: prefersReduced() ? 'auto' : 'smooth' });
    }
    function releaseLockOnIdle(after) {
      clearTimeout(spyLockT);
      var idle;
      var onScr = function () { clearTimeout(idle); idle = setTimeout(done, 140); };
      function done() {
        window.removeEventListener('scroll', onScr);
        if (after && after()) return;
        spyLock = false; spy();
      }
      window.addEventListener('scroll', onScr, { passive: true });
      idle = setTimeout(done, 650);
    }
    /* 24.09.2026: cel liczony raz przed przewijaniem — a po drodze doładowują się sekcje nad nim (obrazki, bloki
       „lazy”), więc na telefonie ściana opinii lądowała ~400 px niżej niż trzeba. Po zatrzymaniu przewijania
       mierzymy jeszcze raz i poprawiamy (najwyżej dwa razy). */
    function scrollToTab(t, tries) {
      var top = t.target.getBoundingClientRect().top + window.pageYOffset - tabsOffset() - 8;
      window.scrollTo({ top: Math.max(0, top), behavior: prefersReduced() ? 'auto' : 'smooth' });
      releaseLockOnIdle(function () {
        var miss = t.target.getBoundingClientRect().top - tabsOffset() - 8;
        var atBottom = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 4;
        if (tries < 2 && Math.abs(miss) > 24 && !(miss > 0 && atBottom)) {
          scrollToTab(t, tries + 1);
          return true;
        }
        return false;
      });
    }
    function wireTabClick(t, i) {
      t.btn.addEventListener('click', function () {
        spyLock = true; clearTimeout(spyLockT);
        setActive(i);
        if (t.tabId) {
          var item = document.querySelector('.product_tabs__item[data-id="' + t.tabId + '"]');
          if (item) item.click();
        }
        setTimeout(function () { scrollToTab(t, 0); }, t.tabId ? 90 : 0);
      });
    }

    if (tabsBar) {
      Array.prototype.slice.call(tabsBar.querySelectorAll('[data-evm-tab], .evm-tab')).forEach(function (btn) {
        var key = btn.getAttribute('data-evm-tab');
        var mapped = key ? tabTargetMap[key] : null;
        if (!mapped || !mapped.target) { btn.remove(); return; }
        var entry = {
          label: (btn.textContent || '').trim(),
          target: mapped.target,
          tabId: btn.getAttribute('data-evm-tab-id') || mapped.tabId,
          btn: btn
        };
        tabsDef.push(entry);
      });
      tabsDef.forEach(wireTabClick);
    }

    var headerHEl = null;
    var headerHCache = null;
    var headerHRaf = 0;
    function headerH() {
      if (headerHCache != null) return headerHCache;
      if (!headerHEl || !headerHEl.isConnected) {
        headerHEl = document.querySelector('.shopify-section-group-header-group .header-wrapper, .section-header, header.header, sticky-header');
      }
      if (!headerHEl) return 0;
      var r = headerHEl.getBoundingClientRect();
      headerHCache = (r.top <= 1 && r.bottom > 0) ? r.bottom : 0;
      if (!headerHRaf) {
        headerHRaf = window.requestAnimationFrame(function () {
          headerHRaf = 0;
          headerHCache = null;
        });
      }
      return headerHCache;
    }
    function tabsOffset() { return headerH() + (tabsBar ? tabsBar.offsetHeight : 0); }
    function setTabsTop() {
      document.documentElement.style.setProperty('--evm-tabs-top', headerH() + 'px');
      document.documentElement.style.setProperty('--evm-preview-top', (headerH() + (tabsBar ? tabsBar.offsetHeight : 46) + 6) + 'px');
    }
    setTabsTop();
    window.addEventListener('resize', setTabsTop);
    (function () {
      var psec = product.closest('.shopify-section') || product;
      var host = psec.parentNode || product.parentNode;
      if (tabsBar && tabsBar.parentNode !== host) host.insertBefore(tabsBar, psec);
      else if (tabsBar && tabsBar.nextSibling !== psec) host.insertBefore(tabsBar, psec);
    })();

    var spyTick = false;
    function spy() {
      spyTick = false;
      if (spyLock) return;
      var pos = window.pageYOffset + tabsOffset() + 50;
      var atBottom = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 4;
      var current = 0, bestTop = -Infinity;
      tabsDef.forEach(function (t, i) {
        var top = t.target.getBoundingClientRect().top + window.pageYOffset;
        if (top <= pos && top > bestTop) { bestTop = top; current = i; }
      });
      if (atBottom) current = tabsDef.length - 1;
      if (tabsDef[activeIdx] && tabsDef[current] && tabsDef[activeIdx].target === tabsDef[current].target) return;
      setActive(current);
    }
    window.addEventListener('scroll', function () {
      if (!spyTick) { spyTick = true; window.requestAnimationFrame(spy); }
    }, { passive: true });

    /* ---------- 2c. OPIS — Liquid snippet (.evm-opis-lede); no JS HTML ---------- */
    (function () {
      var box = document.querySelector('.product_tabs__containers_item[data-id="description"]');
      if (box) box.dataset.evmOpis = '1';
    })();

    /* ---------- 2d. DOSTAWA I PŁATNOŚĆ → stara treść + tylko GLS/Pickup cleanup ---------- */
    (function () {
      var box = document.querySelector('.product_tabs__containers_item[data-id="delivery"]');
      if (!box || box.dataset.evmDelv) return;
      box.dataset.evmDelv = '1';
      var GLS_LOGO = 'https://cdn.shopify.com/s/files/1/0790/9218/7414/files/GLS_Logo_2021_svg.svg?v=1774966899';
      Array.prototype.slice.call(box.querySelectorAll('li, p, div')).forEach(function (node) {
        var t = (node.textContent || '').replace(/\s+/g, ' ').trim();
        var smallRow = node.tagName === 'LI' || (node.children.length === 0 && t.length < 140);
        if (smallRow && /Paczkomat\s+InPost|Punkt\s+odbioru\s+DPD\s+Pickup/i.test(t)) node.remove();
      });
      Array.prototype.slice.call(box.querySelectorAll('ul, ol, p, div')).forEach(function (node) {
        if (!node.textContent.trim() && !node.querySelector('img, svg, iframe, video')) node.remove();
      });
      Array.prototype.slice.call(box.querySelectorAll('strong, b, span, p, li, div')).forEach(function (node) {
        var t = (node.textContent || '').replace(/\s+/g, ' ').trim();
        if (t === 'GLS' && !node.querySelector('img')) {
          node.innerHTML = '<img class="evm-gls-logo" src="' + GLS_LOGO + '" alt="GLS" loading="lazy">';
        }
      });
    })();

    /* ---------- 2e. Product tabs: short labels via Liquid (.evm-tab-label-short) ---------- */
    (function () {
      var short = { description: 'Opis', tech: 'Dane', delivery: 'Dostawa' };
      Array.prototype.slice.call(document.querySelectorAll('.product_tabs__item')).forEach(function (item) {
        var id = item.getAttribute('data-id');
        if (!short[id]) return;
        if (item.querySelector('.evm-tab-label-short')) return;
        item.textContent = short[id];
      });
    })();

    /* ---------- 3. kroki: opisy rodzaju + kolejność stanów ---------- */
    var typeFs = product.querySelector('fieldset[data-name="mats_type"]');
    if (typeFs) {
      typeFs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        var lab = typeFs.querySelector('label[for="' + inp.id + '"]');
        if (!lab) return;
        var v = (inp.dataset.title || inp.value || '').toLowerCase();
        if (v.indexOf('bez rant') > -1) lab.setAttribute('data-evm-desc', 'Lekka ochrona na co dzień');
        else if (v.indexOf('rantami') > -1 || v.indexOf('3d') > -1) lab.setAttribute('data-evm-desc', 'Lepsza ochrona przed wodą i błotem');
      });
      function cleanOfferBadges() {
        Array.prototype.slice.call(typeFs.querySelectorAll('.label_oferta')).forEach(function (badge) {
          if (badge.dataset.evmClean === '1') return;
          badge.dataset.evmClean = '1';
          badge.textContent = 'POLECANE';
          badge.classList.add('evm-offer-badge');
        });
      }
      cleanOfferBadges();
      new MutationObserver(cleanOfferBadges).observe(typeFs, { childList: true, subtree: true });
    }

    function visibleWrappers() {
      var seen = {};
      return Array.prototype.slice.call(product.querySelectorAll('.product__dropdown_wr'))
        .filter(function (w) {
          if (w.classList.contains('evm-summary')) return false;
          /* Do not use offsetParent: wizard CSS hides non-open steps before/during init */
          var k = w.getAttribute('data-dropdown') || w.className;
          if (seen[k]) return false;
          seen[k] = true;
          return true;
        });
    }
    var wrappers = visibleWrappers();
    var required = wrappers.filter(function (w) {
      return w.querySelector('input[required], select[required], textarea[required]');
    });

    function stripNumText(t) {
      var n = t.firstChild;
      while (n && n.nodeType === 3 && !n.nodeValue.trim()) n = n.nextSibling;
      if (n && n.nodeType === 3) n.nodeValue = n.nodeValue.replace(/^\s*\d+\.\s*/, '');
    }
    wrappers.forEach(function (w, i) {
      var t = w.querySelector('.product__dropdown_title');
      if (!t) return;
      t.setAttribute('data-num', i + 1);
      stripNumText(t);
      new MutationObserver(function () { stripNumText(t); }).observe(t, { childList: true });
    });

    /* ---------- WIZARD (prezentacyjnie; logika kroków bez zmian) ---------- */
    var STEP_TOTAL = wrappers.length;
    var progress = product.querySelector('.evm-progress');
    if (!progress) return;
    var progressBar = progress.querySelector('.evm-progress__bar');
    if (progressBar) progressBar.innerHTML = new Array(STEP_TOTAL + 1).join('<i></i>');
    var progressPill = progress.querySelector('.evm-progress__pill');
    if (progressPill) progressPill.textContent = tr('Krok 1 z ', 'Step 1 of ') + STEP_TOTAL;

    function actionLabelFor(w, idx) {
      return tr('Dalej', 'Continue');
    }
    function decorateActionButton(btn, label) {
      if (!btn || btn.dataset.evmActionLabel === label) return;
      btn.dataset.evmActionLabel = label;
      btn.innerHTML = '<span class="evm-btn-label">' + label + '</span><span class="evm-btn-arrow">' + ICONS.chev + '</span>';
      btn.setAttribute('aria-label', label);
    }
    function configScrollExtra(w) {
      return 16;
    }
    function scrollToConfig() {
      var active = openWrapper() || firstUnpassed();
      var top = progress.getBoundingClientRect().top + window.pageYOffset - tabsOffset() - configScrollExtra(active);
      window.scrollTo({ top: Math.max(0, top), behavior: prefersReduced() ? 'auto' : 'smooth' });
    }
    function clickTitle(w) {
      var t = w && w.querySelector('.product__dropdown_title');
      if (!t) return;
      t.style.pointerEvents = 'auto'; t.click(); t.style.pointerEvents = '';
    }
    wrappers.forEach(function (w, i) {
      if (w.querySelector('.evm-back')) return;
      var inner = w.querySelector('.product__dropdown_inner');
      if (!inner) return;
      var dalej = inner.querySelector('.product__dropdown_button');
      var navRow = el('div', 'evm-nav-row');
      if (i > 0) {
        var back = el('button', 'evm-back', ICONS.chev + ' ' + tr('Wstecz', 'Back'));
        back.type = 'button';
        back.addEventListener('click', function (e) {
          e.preventDefault();
          clickTitle(wrappers[i - 1]);
          scrollToConfig();
        });
        navRow.appendChild(back);
      }
      if (dalej) {
        inner.insertBefore(navRow, dalej);
        navRow.appendChild(dalej);
        decorateActionButton(dalej, actionLabelFor(w, i));
      } else {
        var nx = el('button', 'evm-next');
        nx.type = 'button';
        decorateActionButton(nx, actionLabelFor(w, i));
        nx.addEventListener('click', function (e) {
          e.preventDefault();
          w.classList.add('evm-passed');
          if (editReturn || i === wrappers.length - 1) {
            editReturn = false;
            clickTitle(w);
            setTimeout(function () {
              syncAll();
              var top = summary.getBoundingClientRect().top + window.pageYOffset - tabsOffset() - 10;
              window.scrollTo({ top: Math.max(0, top), behavior: prefersReduced() ? 'auto' : 'smooth' });
            }, 60);
          } else {
            clickTitle(wrappers[i + 1]);
            setTimeout(function () { syncAll(); scrollToConfig(); }, 60);
          }
        });
        navRow.appendChild(nx);
        inner.appendChild(navRow);
      }
      if (!navRow.childNodes.length) navRow.remove();
    });

    /* ---------- kroki opcjonalne: strip legacy "(opcjonalne)" from title text ---------- */
    function evmOptionalDecor() {
      wrappers.forEach(function (w) {
        var title = w.querySelector('.product__dropdown_title');
        if (!title) return;
        var txt = title.textContent || '';
        var isHeel = /podpi[eę]t/i.test(txt);
        var isExtras = /dodatkow/i.test(txt) || w.getAttribute('data-dropdown') === 'extras';
        if (!isHeel && !isExtras) return;
        Array.prototype.slice.call(title.childNodes).forEach(function (n) {
          if (n.nodeType === 3 && /opcjonaln/i.test(n.nodeValue)) {
            n.nodeValue = n.nodeValue.replace(/\s*\(\s*opcjonaln\w*\s*\)\s*/i, ' ').replace(/\s+([:：])/, '$1');
          }
        });
      });
    }
    var evmDecorT;
    function evmOptionalDecorSoon() { clearTimeout(evmDecorT); evmDecorT = setTimeout(evmOptionalDecor, 150); }
    [0, 250, 700].forEach(function (d) { setTimeout(evmOptionalDecor, d); });
    new MutationObserver(evmOptionalDecorSoon).observe(product, { childList: true, subtree: true });

    function syncProgress() {
      var open = openWrapper();
      var summary = reachedSummary();
      var fu = firstUnpassed();
      var idx = open ? wrappers.indexOf(open) : (summary ? STEP_TOTAL - 1 : (fu ? wrappers.indexOf(fu) : 0));
      if (idx < 0) idx = 0;
      var pill = progress.querySelector('.evm-progress__pill');
      if (pill) pill.textContent = summary ? tr('Podsumowanie', 'Summary') : (tr('Krok ', 'Step ') + (Math.min(idx, STEP_TOTAL - 1) + 1) + tr(' z ', ' of ') + STEP_TOTAL);
      var segs = progress.querySelectorAll('.evm-progress__bar i');
      // Fill by wizard position only. Optional heel/extras ship with Liquid
      // super_done and must not paint the whole bar red ahead of the open step.
      for (var i = 0; i < segs.length; i++) {
        var isCurrent = !summary && i === idx;
        var filled = summary || i <= idx;
        segs[i].classList.toggle('done', filled);
        segs[i].classList.toggle('current', isCurrent);
      }
    }
    function wizardGuard() {
      if (openWrapper()) return;
      if (!reachedSummary()) {
        var w = firstUnpassed();
        var t = w && w.querySelector('.product__dropdown_title');
        if (t) { t.style.pointerEvents = 'auto'; t.click(); t.style.pointerEvents = ''; }
      }
    }
    document.documentElement.classList.add('evm-wizard');
    var STEP_NAMES = {
      year: tr('Wybierz rok', 'Select the year'),
      mats_set_type: tr('Wybierz zestaw', 'Select the set'),
      mat_patterns_colors: tr('Wybierz kolory', 'Select colours'),
      heel: tr('Podpiętki', 'Heel pads'),
      extras: tr('Akcesoria', 'Accessories')
    };
    function stepKey(w) {
      return w.getAttribute('data-dropdown') || (w.className.indexOf('--heel') > -1 ? 'heel' : 'extras');
    }
    function allRequiredDone() {
      return required.every(function (w) { return w.classList.contains('complete'); });
    }
    function openWrapper() {
      return wrappers.find(function (w) { return w.classList.contains('open'); }) || null;
    }
    function firstIncomplete() {
      return required.find(function (w) { return !w.classList.contains('complete'); }) || null;
    }
    function stepPassed(w) { return w.classList.contains('complete') || w.classList.contains('evm-passed'); }
    function firstUnpassed() { return wrappers.find(function (w) { return !stepPassed(w); }) || null; }
    function reachedSummary() { return wrappers.every(stepPassed) && !openWrapper(); }
    function yearChosen() { var y = product.querySelector('#rok-produkcji'); return !!(y && y.value); }

    /* ---------- 4. sticky buybar ---------- */
    var sticky = product.querySelector('.sticky_container');
    var stickyBtn = sticky ? sticky.querySelector('.sticky_add_to_cart') : null;
    /* Sticky „Dodaj do koszyka" tylko klika ukryty natywny submit i sam nie wiedzial, ze
       dodawanie trwa — klient nie widzial reakcji i klikal drugi raz (druga podpietka).
       Stan bierzemy z natywnego przycisku (product-form.js ustawia aria-disabled). */
    function evmAtcBusy() {
      var sub = product.querySelector('product-form button[name="add"], .product-form__submit');
      return !!(sub && sub.getAttribute('aria-disabled') === 'true');
    }
    var priceSrc = sticky ? sticky.querySelector('.sticky_config_price_price') : null;
    var evmMainPriceNode = null;
    function evmMoney(txt) {
      var m = String(txt || '').replace(/\s+/g, ' ').match(/(\d+(?:[.,]\d+)?)/);
      return m ? Math.round(parseFloat(m[1].replace(',', '.'))) : null;
    }
    /* Doplata za ksztalt „Krople” to osobna pozycja w koszyku (100 zl), wiec cena
       wariantu jej nie zawiera i kwota nie drgala przy zmianie ksztaltu. Doliczamy
       ja do obu kwot — i do aktualnej, i do przekreslonej — bo sama doplata nie jest
       objeta rabatem, wiec inaczej procent obnizki bylby zawyzony. */
    var EVM_DROP_SURCHARGE_PLN = 100;
    function evmDropSurcharge() {
      var fs = product.querySelector('fieldset[data-type="matPattern"]');
      var checked = fs && fs.querySelector('input[type="radio"]:checked');
      if (!checked) return 0;
      var byData = (checked.getAttribute('data-value') || '').toLowerCase() === 'drop';
      var byValue = /krople/i.test(checked.value || '');
      return (byData || byValue) ? EVM_DROP_SURCHARGE_PLN : 0;
    }
    function evmSelectedSetPriceParts() {
      var checked = product.querySelector('fieldset[data-name="mats_set"] input[type="radio"]:checked');
      var label = checked && (checked.closest('label') || product.querySelector('label[for="' + checked.id + '"]'));
      var nowEl = label && label.querySelector('.evm-set-price b');
      var oldEl = label && label.querySelector('.evm-set-price s');
      var now = evmMoney(nowEl ? nowEl.textContent : '');
      var old = evmMoney(oldEl ? oldEl.textContent : '');
      if (now == null && priceSrc) now = evmMoney(priceSrc.textContent);
      if (old != null && now != null && old <= now) old = null;
      var surcharge = evmDropSurcharge();
      if (surcharge) {
        if (now != null) now += surcharge;
        if (old != null) old += surcharge;
      }
      return { now: now, old: old };
    }
    var evmPriceRenderT = 0;
    function evmRenderMainPriceNow() {
      var box = product.querySelector('.main_price') || document.querySelector('.main_price');
      if (!box) return;
      var host = box.parentNode || box;
      if (!evmMainPriceNode) {
        evmMainPriceNode = document.querySelector('.evm-main-price-custom') || el('div', 'evm-main-price-custom', '');
      }
      if (evmMainPriceNode.parentNode !== host || evmMainPriceNode.nextSibling !== box) host.insertBefore(evmMainPriceNode, box);
      var parts = evmSelectedSetPriceParts();
      if (!parts.now) {
        if (evmMainPriceNode.innerHTML) evmMainPriceNode.innerHTML = '';
        return;
      }
      var html = '<span class="evm-main-now">' + parts.now + ' zł</span>';
      if (parts.old) {
        var pct = Math.round((1 - (parts.now / parts.old)) * 100);
        html += '<span class="evm-main-old">' + parts.old + ' zł</span>';
        if (pct > 0) html += '<span class="evm-main-pct">-' + pct + '%</span>';
      }
      if (evmMainPriceNode.innerHTML !== html) evmMainPriceNode.innerHTML = html;
      var disc = document.querySelector('.evm-gal-disc');
      if (disc) {
        if (parts.old && parts.now && parts.old > parts.now) {
          var gPct = Math.round((1 - (parts.now / parts.old)) * 100);
          var discTxt = '−' + gPct + '%';
          if (disc.textContent !== discTxt) disc.textContent = discTxt;
          disc.hidden = false;
        } else if (!disc.hidden || disc.textContent) {
          disc.textContent = '';
          disc.hidden = true;
        }
      }
    }
    function evmRenderMainPrice() {
      clearTimeout(evmPriceRenderT);
      evmPriceRenderT = setTimeout(evmRenderMainPriceNow, 40);
    }
    // Boot only — no setInterval / body-wide MutationObserver (Clarity/Klaviyo mutate constantly).
    [0, 200, 800, 2000].forEach(function (delay) {
      setTimeout(evmRenderMainPriceNow, delay);
    });
    product.addEventListener('change', function () { evmRenderMainPrice(); }, true);
    var setFsPrice = product.querySelector('fieldset[data-name="mats_set"]');
    if (setFsPrice) {
      new MutationObserver(function () { evmRenderMainPrice(); })
        .observe(setFsPrice, { childList: true, subtree: true, characterData: true });
    }
    // Variant prices update asynchronously; refresh the CRO price after Shopify updates the source.
    if (priceSrc && window.MutationObserver) {
      new MutationObserver(function () { evmRenderMainPrice(); })
        .observe(priceSrc, { childList: true, subtree: true, characterData: true });
    }
    var bbMeta, bbPrice, bbStep, bbLabel, bbBack;
    /* Buybar to warstwa wylacznie mobilna: na desktopie karta konfiguratora ma
       wlasne CTA, a dolny pasek tylko dublowal cene i numer kroku. Na szerokosciach
       >= 1024 px nie budujemy go wcale — zadnego DOM-u, zadnych nasluchow. */
    var bbMedia = window.matchMedia('(max-width: 1023px)');
    function setupBuybar() {
      if (bbPrice) return;
      if (!sticky || !stickyBtn || !bbMedia.matches) return;
      bbMeta = sticky.querySelector('.evm-bb-meta');
      if (!bbMeta) {
        bbMeta = el('div', 'evm-bb-meta',
          '<div class="evm-bb-price"><span class="evm-bb-now"></span><s class="evm-bb-old"></s></div>');
        sticky.insertBefore(bbMeta, stickyBtn);
      }
      bbPrice = bbMeta.querySelector('.evm-bb-now');
      bbBack = sticky.querySelector('.evm-bb-back');
      if (!bbBack) {
        bbBack = el('button', 'evm-bb-back', ICONS.chev + '<span>' + tr('Wstecz', 'Back') + '</span>');
        bbBack.type = 'button';
        bbBack.setAttribute('aria-label', tr('Wstecz', 'Back'));
        sticky.insertBefore(bbBack, stickyBtn);
      }
      bbStep = sticky.querySelector('.evm-bb-step');
      if (!bbStep) {
        bbStep = el('span', 'evm-bb-step', '');
        sticky.insertBefore(bbStep, stickyBtn);
      }
      bbLabel = stickyBtn.querySelector('.evm-bb-label');
      if (!bbLabel) {
        bbLabel = el('span', 'evm-bb-label', tr('Dalej', 'Continue'));
        stickyBtn.insertBefore(bbLabel, stickyBtn.firstChild);
      }
      if (!stickyBtn.querySelector('.evm-bb-arrow')) {
        stickyBtn.insertBefore(el('span', 'evm-bb-arrow', ICONS.chev), bbLabel.nextSibling);
      }
      stickyBtn.setAttribute('aria-label', tr('Dalej', 'Continue'));

      var bbNavBusy = false;
      function withBuybarLock(fn) {
        if (bbNavBusy) return;
        bbNavBusy = true;
        fn();
        window.setTimeout(function () { bbNavBusy = false; }, 180);
      }
      function settleBuybarNavigation() {
        [70, 240].forEach(function (delay) {
          window.setTimeout(function () { syncAll(); scrollToConfig(); }, delay);
        });
      }

      bbBack.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        withBuybarLock(function () {
          var current = openWrapper();
          var idx = current ? wrappers.indexOf(current) : wrappers.length;
          if (idx <= 0) return;
          var previous = wrappers[idx - 1];
          previous.classList.remove('evm-passed');
          clickTitle(previous);
          window.setTimeout(function () { syncAll(); scrollToConfig(); }, 60);
        });
      }, true);

      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (evmAtcBusy()) return;
        withBuybarLock(function () {
          if (reachedSummary()) {
            addToCart();
            syncBuybar();
            return;
          }
          var w = openWrapper() || firstUnpassed();
          if (!w) return;
          if (!w.classList.contains('open')) {
            clickTitle(w);
            window.setTimeout(function () { syncAll(); scrollToConfig(); }, 60);
            return;
          }
          var nx = w.querySelector('.evm-next');
          if (nx) { nx.click(); settleBuybarNavigation(); return; }
          var btn = w.querySelector('.product__dropdown_button');
          if (btn) { btn.click(); settleBuybarNavigation(); return; }
          scrollToConfig();
        });
      }, true);
      if (sticky.parentNode !== document.body) document.body.appendChild(sticky);
    }
    setupBuybar();
    /* Zwezenie okna (obrot tabletu, tryb responsywny w przegladarce) nie moze zostawic
       widoku mobilnego bez paska — budujemy go przy pierwszym wejsciu w zakres mobilny. */
    if (bbMedia.addEventListener) {
      bbMedia.addEventListener('change', function () { setupBuybar(); syncAll(); });
    }

    function syncBuybar() {
      if (!bbPrice) return;
      var cur = (priceSrc ? priceSrc.textContent.trim() : '') || '';
      bbPrice.textContent = cur;
      var oldEl = bbMeta.querySelector('.evm-bb-old');
      var selectedOld = product.querySelector('fieldset[data-name="mats_set"] input[type="radio"]:checked + label .evm-set-price s');
      if (oldEl) oldEl.textContent = selectedOld ? (selectedOld.textContent || '').trim() : '';
      var open = openWrapper();
      var atEnd = reachedSummary();
      stickyBtn.classList.toggle('evm-is-atc', atEnd);
      var current = open || firstUnpassed();
      var currentIndex = current ? wrappers.indexOf(current) : wrappers.length;
      if (bbBack) {
        bbBack.hidden = currentIndex <= 0;
        bbBack.disabled = currentIndex <= 0;
      }
      var atcBusy = evmAtcBusy();
      stickyBtn.classList.toggle('evm-atc-busy', atcBusy);
      stickyBtn.setAttribute('aria-disabled', atcBusy ? 'true' : 'false');
      if (atEnd) {
        bbStep.textContent = atcBusy ? tr('Chwila', 'Wait') : tr('Gotowe', 'Ready');
        bbLabel.textContent = atcBusy ? tr('Dodawanie…', 'Adding…') : tr('Dodaj do koszyka', 'Add to cart');
      } else {
        var w = current;
        var key = w ? stepKey(w) : 'year';
        var idx = w ? (wrappers.indexOf(w) + 1) : 1;
        bbStep.textContent = tr('Krok ', 'Step ') + idx + '/' + wrappers.length;
        bbLabel.textContent = actionLabelFor(w, idx - 1);
      }
    }

    /* ---------- 5. adaptacyjna darmowa dostawa (koszyk + cena produktu) ---------- */
    var FREE_AT = 600;
    var ship = product.querySelector('.label_delivery[data-evm-ship]') || product.querySelector('.label_delivery');
    var shipBar, shipTxt, shipIcon;
    var cartTotalPln = 0;
    if (ship) {
      var freeAtAttr = parseFloat(ship.getAttribute('data-evm-free-at'));
      if (freeAtAttr > 0) FREE_AT = freeAtAttr;
      shipIcon = ship.querySelector('.evm-ship-ico');
      shipTxt = ship.querySelector('.evm-ship-txt');
      shipBar = ship.querySelector('.evm-ship-bar');
      var shipFallback = ship.querySelector('.evm-ship-fallback');
      if (shipFallback) shipFallback.setAttribute('hidden', '');
      if (!shipTxt || !shipBar) {
        var legacy = (shipTxt ? '' : ship.textContent.trim());
        if (!shipIcon) {
          shipIcon = el('span', 'evm-ship-ico', ICONS.truck);
        }
        if (!shipTxt) {
          shipTxt = el('span', 'evm-ship-txt', legacy || '');
        }
        if (!shipBar) {
          shipBar = el('span', 'evm-ship-bar', '<i></i>');
        }
        if (!ship.querySelector('.evm-ship-ico') || !ship.querySelector('.evm-ship-txt') || !ship.querySelector('.evm-ship-bar')) {
          ship.textContent = '';
          ship.appendChild(shipIcon);
          ship.appendChild(shipTxt);
          ship.appendChild(shipBar);
        }
      }
      if (shipBar && !shipBar.firstChild) shipBar.appendChild(document.createElement('i'));
    }
    function productTotal() {
      var t = parsePLN(priceSrc && priceSrc.textContent);
      if (!t) t = parsePLN((product.querySelector('.option__price_regular') || {}).textContent);
      if (!t) t = parsePLN((product.querySelector('.main_price, .price-item--regular, #google_prices') || {}).textContent);
      return t || 0;
    }
    function currentTotal() {
      return (cartTotalPln || 0) + productTotal();
    }
    function syncShip() {
      if (!ship || !shipTxt || !shipBar) return;
      var total = currentTotal();
      if (total >= FREE_AT) {
        ship.classList.add('evm-free');
        if (shipIcon) shipIcon.innerHTML = ICONS.check;
        shipTxt.innerHTML = '<span class="evm-ship-h">' + tr('Darmowa dostawa od ', 'Free delivery from ') + FREE_AT + ' zł</span>' +
          '<span class="evm-ship-s">' + tr('Twój koszyk kwalifikuje się do darmowej dostawy', 'Your basket qualifies for free delivery') + '</span>';
      } else {
        ship.classList.remove('evm-free');
        if (shipIcon) shipIcon.innerHTML = ICONS.truck;
        var left = Math.ceil(FREE_AT - total);
        shipTxt.innerHTML = '<span class="evm-ship-h">' + tr('Darmowa dostawa od ', 'Free delivery from ') + FREE_AT + ' zł</span>' +
          '<span class="evm-ship-s">' + (EVM_EN ? left + ' zł left to qualify for free delivery' : 'Brakuje jeszcze ' + left + ' zł do darmowej wysyłki') + '</span>';
      }
      if (shipBar.firstChild) {
        shipBar.firstChild.style.width = Math.min(100, Math.round((total / FREE_AT) * 100)) + '%';
      }
      /* Netpeak P11 (23.09.2026): cena dostawy w karcie — od progu przekreślona, obok „0 zł”. */
      var costRow = ship.querySelector('.evm-np-ship-cost');
      var costAttr = parseFloat(ship.getAttribute('data-evm-ship-cost'));
      if (costRow && costAttr > 0) {
        var costOld = costRow.querySelector('.evm-np-ship-cost__old');
        var costNow = costRow.querySelector('.evm-np-ship-cost__now');
        var costFree = total >= FREE_AT;
        costRow.classList.toggle('is-free', costFree);
        if (costOld) costOld.hidden = !costFree;
        if (costNow) {
          if (!costNow.hasAttribute('data-evm-cost')) costNow.setAttribute('data-evm-cost', costNow.textContent);
          costNow.textContent = costFree ? '0\u00a0zł' : costNow.getAttribute('data-evm-cost');
        }
      }
    }
    function refreshCartShip() {
      if (!ship) return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          cartTotalPln = cart && cart.total_price != null ? (cart.total_price / 100) : 0;
          syncShip();
        })
        .catch(function () {
          syncShip();
        });
    }
    refreshCartShip();
    document.addEventListener('cart:updated', refreshCartShip);
    document.addEventListener('cart:refresh', refreshCartShip);
    window.addEventListener('pageshow', refreshCartShip);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refreshCartShip();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(refreshCartShip, 50);
      });
    }

    /* ---------- 5b. „Produkt wykonywany..." → hide if Liquid .evm-process exists ---------- */
    (function () {
      var chips = product.querySelector('.evm-process');
      if (!chips) return;
      var nodes = Array.prototype.slice.call(product.querySelectorAll('p, div'))
        .filter(function (n) {
          if (n.classList && n.classList.contains('evm-process')) return false;
          return n.children.length <= 2 && /Produkt wykonywany na zamówienie/i.test(n.textContent || '') && (n.textContent || '').length < 220;
        });
      var target = nodes[nodes.length - 1];
      if (target) target.style.setProperty('display', 'none', 'important');
    })();

    /* ---------- 6. Podsumowanie (Liquid shell) ---------- */
    var summary = product.querySelector('.evm-summary') || document.querySelector('.evm-summary');
    if (!summary) return;
    if (!summary.querySelector('.evm-summary__rows')) {
      summary.appendChild(el('div', 'evm-summary__rows', ''));
    }
    summary.style.display = 'none';
    var editReturn = false;

    function checkedLabelImg(fieldsetSel, inputSel) {
      var scopes = Array.prototype.slice.call(product.querySelectorAll(fieldsetSel));
      scopes.sort(function (a, b) { return (b.offsetParent ? 1 : 0) - (a.offsetParent ? 1 : 0); });
      for (var i = 0; i < scopes.length; i++) {
        var scope = scopes[i];
        var inp = scope.querySelector(inputSel + ':checked');
        if (!inp) continue;
        var lab = inp.closest('label') ||
          (inp.id ? scope.querySelector('label[for="' + inp.id + '"]') : null) ||
          (inp.nextElementSibling && inp.nextElementSibling.tagName === 'LABEL' ? inp.nextElementSibling : null);
        var img = lab ? lab.querySelector('img') : null;
        var src = img ? (img.currentSrc || img.src || img.getAttribute('data-src') || img.getAttribute('data-evm-src') || '') : '';
        if (/no-image|shopifycloud\/storefront/i.test(src)) src = '';
        if (src) {
          // iOS Retina: option thumbs may resolve to tiny CDN sizes — prefer ≥400w in summary.
          src = src
            .replace(/_(\d+)x(\d*)(?=@|[.?#]|$)/g, function (m, w, h) {
              var nw = Math.max(parseInt(w, 10) || 0, 400);
              return '_' + nw + 'x' + (h || '');
            })
            .replace(/([?&]width=)(\d+)/g, function (m, p, w) {
              return p + String(Math.max(parseInt(w, 10) || 0, 400));
            });
        }
        return { img: src, txt: inp.dataset.title || inp.value || '' };
      }
      return { img: '', txt: '' };
    }
    function rowHTML(icon, imgSrc, k, v, editKey, extraImg, opts) {
      opts = opts || {};
      var editLabel = opts.editLabel || tr('Zmień', 'Change');
      var emptyCls = opts.empty ? ' evm-sum-row--empty' : '';
      return '<div class="evm-sum-row' + emptyCls + '">' +
        '<span class="evm-sum-fig">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="">' : icon || '') +
        (extraImg ? '<img class="evm-sum-fig__extra" src="' + extraImg + '" alt="">' : '') +
        '</span>' +
        '<span class="evm-sum-txt"><span class="evm-sum-k">' + enValue(k) + '</span><span class="evm-sum-v">' + enValue(v) + '</span></span>' +
        (editKey ? '<button type="button" class="evm-sum-edit" data-edit="' + editKey + '">' + editLabel + ' ' + ICONS.pencil + '</button>' : '') +
        '</div>';
    }
    function buildSummary() {
      var rows = '';
      var yearSel = product.querySelector('#rok-produkcji');
      var year = yearSel && yearSel.value ? yearSel.value : '';
      rows += rowHTML(ICONS.car, '', tr('Samochód', 'Vehicle'), vehicle + (year ? ' · ' + year : ''), '');

      /* 13.10.2026: typy nadwozia bez wyboru „Rodzaj dywaników” (klasa z evm-np-indyw.js) – w podsumowaniu bez „3D BEZ RANTÓW” */
      var typeInfo = product.classList.contains('evm-np-norodzaj') ? { img: '', txt: '' } : checkedLabelImg('fieldset[data-name="mats_type"]', 'input[type="radio"]');
      var setInfo = checkedLabelImg('fieldset[data-name="mats_set"]', 'input[type="radio"]');
      rows += rowHTML('', setInfo.img || typeInfo.img, tr('Wariant', 'Variant'),
        (typeInfo.txt ? enValue(typeInfo.txt) + ' · ' : '') + (setInfo.txt ? enValue(setInfo.txt) : '—'), 'mats_set_type');

      var patInfo = checkedLabelImg('fieldset[data-type="matPattern"]', 'input[type="radio"]');
      rows += rowHTML('', patInfo.img, tr('Kształt komórek', 'Cell pattern'), patInfo.txt ? enValue(patInfo.txt) : '—', 'mat_patterns_colors');

      var matInfo = checkedLabelImg('fieldset[data-type="matColor"]', 'input[type="radio"]');
      var trimInfo = checkedLabelImg('fieldset[data-type="trimColor"]', 'input[type="radio"]');
      rows += rowHTML('', matInfo.img, tr('Kolory (materiał / obszycie)', 'Colours (mat / trim)'),
        (matInfo.txt ? enValue(matInfo.txt) : '—') + ' / ' + (trimInfo.txt ? enValue(trimInfo.txt) : '—'), 'mat_patterns_colors', trimInfo.img);

      function itemInfo(c) {
        var it = c.closest('.product__upsell_item, .product__extras_item');
        var img = it && it.querySelector('.product__upsell_image, img');
        var t = it && it.querySelector('.product__upsell_item_title');
        var pr = it && it.querySelector('.product__upsell_price');
        var src = img ? (img.currentSrc || img.src) : '';
        if (src) {
          src = src
            .replace(/_(\d+)x(\d*)(?=@|[.?#]|$)/g, function (m, w, h) {
              var nw = Math.max(parseInt(w, 10) || 0, 400);
              return '_' + nw + 'x' + (h || '');
            })
            .replace(/([?&]width=)(\d+)/g, function (m, p, w) {
              return p + String(Math.max(parseInt(w, 10) || 0, 400));
            });
        }
        return {
          img: src,
          name: enValue(t ? t.textContent.trim() : (c.dataset.title || tr('Pozycja', 'Item'))),
          price: pr ? pr.textContent.trim() : ''
        };
      }

      var hasHeelStep = !!product.querySelector('.product__dropdown_wr--heel, [data-dropdown="heel"]');
      var heelChecked = Array.prototype.slice.call(product.querySelectorAll('input[name="product__upsell"]:checked'));
      if (heelChecked.length) {
        heelChecked.forEach(function (c) {
          var f = itemInfo(c);
          rows += rowHTML(ICONS.target, f.img, tr('Podpiętka', 'Heel pad'), f.name + (f.price ? ' · ' + f.price : ''), 'heel');
        });
      } else if (hasHeelStep) {
        rows += rowHTML(ICONS.heelPad, '', tr('Podpiętki', 'Heel pads'), tr('Opcjonalnie', 'Optional'), 'heel', '', {
          empty: true,
          editLabel: tr('Dodaj', 'Add')
        });
      }

      var hasExtrasStep = !!product.querySelector('.product__dropdown_wr--extras, [data-dropdown="extras"]');
      var exChecked = Array.prototype.slice.call(product.querySelectorAll('input[name="product__extras"]:checked'));
      if (exChecked.length) {
        exChecked.forEach(function (c) {
          var f = itemInfo(c);
          rows += rowHTML(ICONS.box, f.img, tr('Akcesorium', 'Accessory'), f.name + (f.price ? ' · ' + f.price : ''), 'extras');
        });
      } else if (hasExtrasStep) {
        rows += rowHTML(ICONS.extrasBox, '', tr('Dodatkowe opcje', 'Extras'), tr('Opcjonalnie', 'Optional'), 'extras', '', {
          empty: true,
          editLabel: tr('Dodaj', 'Add')
        });
      }

      var rowsEl = summary.querySelector('.evm-summary__rows');
      if (rowsEl && rowsEl.dataset.evmRows !== rows) {
        rowsEl.dataset.evmRows = rows;
        rowsEl.innerHTML = rows;
      }
    }
    summary.addEventListener('click', function (e) {
      var b = e.target.closest('.evm-sum-edit');
      if (!b) return;
      var key = b.getAttribute('data-edit');
      if (key === 'year') { changeVehicle(); return; }
      var w = wrappers.find(function (x) { return stepKey(x) === key; }) ||
              product.querySelector('.product__dropdown_wr[data-dropdown="' + key + '"]');
      if (!w) return;
      editReturn = true;
      if (!w.classList.contains('open')) {
        var t = w.querySelector('.product__dropdown_title');
        if (t) t.click();
      }
      var top = w.getBoundingClientRect().top + window.pageYOffset - tabsOffset() - configScrollExtra(w);
      window.scrollTo({ top: top, behavior: prefersReduced() ? 'auto' : 'smooth' });
    });

    product.addEventListener('click', function (e) {
      var dalej = e.target.closest('.product__dropdown_button');
      if (!dalej) return;
      setTimeout(function () {
        if (editReturn) {
          editReturn = false;
          var open = openWrapper();
          if (open) {
            var t = open.querySelector('.product__dropdown_title');
            if (t) { t.style.pointerEvents = 'auto'; t.click(); t.style.pointerEvents = ''; }
          }
        }
        syncAll();
        var openNow = openWrapper();
        // Already-checked heels/extras need .active so Kolor/Montaż options are visible
        if (openNow && (openNow.classList.contains('product__dropdown_wr--heel') || openNow.classList.contains('product__dropdown_wr--extras') || openNow.getAttribute('data-dropdown') === 'extras')) {
          Array.prototype.forEach.call(openNow.querySelectorAll('.product__upsell_item, .product__extras_item'), function (item) {
            var inp = item.querySelector('input[name="product__upsell"], input[name="product__extras"]');
            if (inp) item.classList.toggle('active', !!inp.checked);
          });
        }
        if (openNow) {
          scrollToConfig();
        } else {
          var top = summary.getBoundingClientRect().top + window.pageYOffset - tabsOffset() - 10;
          window.scrollTo({ top: Math.max(0, top), behavior: prefersReduced() ? 'auto' : 'smooth' });
        }
      }, 80);
    });

    function refreshConfigTotalPrice() {
      try {
        var vr = product.querySelector('variant-radios') || document.querySelector('variant-radios');
        if (vr && typeof vr.updatePrices === 'function') vr.updatePrices();
      } catch (e) {}
    }
    function syncSummaryAtcLabel() {
      var atc = summary.querySelector('.evm-sum-atc');
      if (!atc) return;
      var busy = evmAtcBusy();
      atc.classList.toggle('evm-atc-busy', busy);
      atc.setAttribute('aria-disabled', busy ? 'true' : 'false');
      var next = busy
        ? tr('Dodawanie…', 'Adding…')
        : tr('Dodaj do koszyka', 'Add to cart') + ' - ' + (priceSrc ? priceSrc.textContent.trim() : '');
      if (atc.textContent !== next) atc.textContent = next;
    }
    function syncSummary() {
      var show = reachedSummary();
      var wasOn = summary.classList.contains('is-on');
      summary.classList.toggle('is-on', show);
      if (show) {
        if (summary.hasAttribute('hidden')) summary.removeAttribute('hidden');
        if (summary.style.display === 'none') summary.style.display = '';
        buildSummary();
        // Price refresh only when entering summary or on explicit upsell/set change — not every sync tick
        if (!wasOn) refreshConfigTotalPrice();
        syncSummaryAtcLabel();
      } else if (wasOn || !summary.hasAttribute('hidden')) {
        summary.setAttribute('hidden', '');
        summary.style.display = 'none';
      }
    }

    Array.prototype.slice.call(document.querySelectorAll('.image-with-text__text')).forEach(function (box) {
      if (box.dataset.evmWarningWrapped) return;
      var nodes = Array.prototype.slice.call(box.childNodes);
      var start = nodes.findIndex(function (n) {
        return ((n.textContent || '').toLowerCase().indexOf('uwaga') > -1);
      });
      if (start < 0) return;
      var card = el('div', 'evm-warning-card', '');
      box.insertBefore(card, nodes[start]);
      for (var i = start; i < nodes.length; i++) card.appendChild(nodes[i]);
      box.dataset.evmWarningWrapped = '1';
    });

    /* ========== 8. FUNKCJE MAKIETY ========== */

    /* Preview owned by product-config.js (desktop under gallery, mobile popup).
       CRO must NOT relocate or gate .product__config_image--mobile. */
    var nativePreview = null;
    var lastPreviewImg = '';
    function syncPreview() { /* no-op: product-config.js owns mobile popup preview */ }

    /* 8c. darmowa dostawa → pod konfigurator (widoczna przy podsumowaniu).
       28.09.2026 (właściciel, zdj. 6): pod kafelkami Produkcja / Dostawa (.evm-process), nie nad nimi. */
    if (ship && summary && summary.parentNode) {
      var shipWrap = ship.closest('.evm-ship-outer') || el('div', 'evm-ship-outer');
      if (ship.parentNode !== shipWrap) shipWrap.appendChild(ship);
      var shipAfter = summary.parentNode.querySelector(':scope > .evm-process') || summary;
      if (shipWrap.parentNode !== shipAfter.parentNode || shipWrap.previousSibling !== shipAfter) {
        shipAfter.parentNode.insertBefore(shipWrap, shipAfter.nextSibling);
      }
    }

    /* 8d. Popularne pary kolorów + „Dostosuj kolory" (Liquid) */
    (function () {
      var colorsStep = product.querySelector('.product__dropdown_wr[data-dropdown="mat_patterns_colors"]');
      if (!colorsStep) return;
      function setColor(type, dv) {
        var inps = colorsStep.querySelectorAll('fieldset[data-type="' + type + '"] input[data-value="' + dv + '"]');
        Array.prototype.forEach.call(inps, function (inp) {
          if (!inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      }
      var pairsWrap = colorsStep.querySelector('.evm-pairs-wrap');
      var toggle = colorsStep.querySelector('.evm-colors-toggle');
      if (!pairsWrap || !toggle) return;
      var pairsRowEl = pairsWrap.querySelector('.evm-pairs') || pairsWrap;
      Array.prototype.slice.call(pairsWrap.querySelectorAll('.evm-pair[data-mat][data-trim]')).forEach(function (b) {
        b.addEventListener('click', function () {
          Array.prototype.forEach.call(pairsRowEl.querySelectorAll('.evm-pair'), function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          setColor('matColor', b.getAttribute('data-mat'));
          setColor('trimColor', b.getAttribute('data-trim'));
          setTimeout(syncAll, 60);
        });
      });
      toggle.addEventListener('click', function () {
        colorsStep.classList.toggle('evm-colors-open');
        toggle.classList.toggle('open');
      });
      var firstPair = pairsWrap.querySelector('.evm-pair[data-mat][data-trim]');
      if (firstPair && !window.__evmMatCfgSkipPairs) {
        Array.prototype.forEach.call(pairsRowEl.querySelectorAll('.evm-pair'), function (x) { x.classList.remove('on'); });
        firstPair.classList.add('on');
        setColor('matColor', firstPair.getAttribute('data-mat'));
        setColor('trimColor', firstPair.getAttribute('data-trim'));
      }
      colorsStep.classList.add('evm-has-pairs');
    })();

    /* 8e. ceny per-zestaw (wg wybranego RODZAJU) + nazwy + bestseller + sort */
    (function () {
      var setFs = product.querySelector('fieldset[data-name="mats_set"]');
      var typeFs = product.querySelector('fieldset[data-name="mats_type"]');
      if (!setFs) return;
      var setPos = parseInt(setFs.getAttribute('data-option-position') || '0', 10);
      var typePos = typeFs ? parseInt(typeFs.getAttribute('data-option-position') || '0', 10) : 0;
      var vjson = null;
      var sc = product.querySelector('variant-radios script[type="application/json"]');
      try { vjson = JSON.parse(sc.textContent); } catch (e) { }
      if (!vjson || !setPos) return;
      function currentType() { var t = typeFs && typeFs.querySelector('input:checked'); return t ? t.value : null; }
      function priceFor(setVal) {
        var tv = currentType(), min = null;
        vjson.forEach(function (v) {
          if (v['option' + setPos] !== setVal) return;
          if (typePos && tv != null && v['option' + typePos] !== tv) return;
          var pr = (v.price || 0) / 100;
          if (min == null || pr < min) min = pr;
        });
        return min;
      }
      function niceSet(val) {
        if (EVM_EN) return { name: val || '', sub: '' };
        var v = (val || '').toLowerCase();
        var p = /prz[oó]d/.test(v), t = /ty[łl]/.test(v), b = /baga/.test(v), k = /kierowc/.test(v), r3 = /3\s*r(z[ąa]d|z[ęe]dy)/.test(v);
        /* 06.10: „2 bagażniki” w podpisie tylko gdy komplet ma oba (minivan); bus „3 rzędy + bagażnik duży (całe auto)” ma jeden */
        if (/ca[łl]e auto/.test(v)) return { name: 'Całe auto + ' + (/du[żz]y/.test(v) ? 'duży' : 'mały') + ' bagażnik', sub: /2\s*baga|ma[łl]y i du[żz]y/.test(v) ? '3 rzędy + 2 bagażniki' : '3 rzędy + bagażnik' };
        if (/du[żz]a mata/.test(v) && b) return { name: 'Duża mata bagażnika', sub: 'sam bagażnik' };
        if (/bez\s*tunel/.test(v)) return { name: 'Przód — bez tunelu', sub: '' };
        if (/z\s*tunel/.test(v)) return { name: 'Przód — z tunelem', sub: '' };
        var r1o = /^\s*1\s*rz[ąa]d/.test(v), r2o = /^\s*2\s*rz[ęe]d/.test(v), r3o = /^\s*3\s*rz[ęe]d/.test(v);
        if (r1o && b) return { name: '1 rząd + bagażnik', sub: 'kabina + przestrzeń' };
        if (r1o) return { name: '1 rząd', sub: 'przód / kabina' };
        if (r2o && b) return { name: '2 rzędy + bagażnik', sub: '' };
        if (r2o) return { name: '2 rzędy', sub: '' };
        /* two trunks must win over the generic '3 rzędy + bagażnik' rule below,
           otherwise '3 rzędy + 2 Bagażniki (Duży | Mały)' renders the same label
           as 'Przód + tył + 3 rząd + Duży bagażnik'. */
        if (r3o && b && /2\s*baga/.test(v)) return { name: '3 rzędy + duży bagażnik i mały bagażnik', sub: 'Duży + mały bagażnik' };
        if (r3o && b) return { name: '3 rzędy + ' + (/du[żz]y/.test(v) ? 'duży' : 'mały') + ' bagażnik', sub: '' };
        if (r3o) return { name: '3 rzędy', sub: 'całe wnętrze' };
        if (/baga[żz]nik\s*ma[łl]y/.test(v)) return { name: 'Bagażnik mały', sub: '' };
        if (/baga[żz]nik\s*du[żz]y/.test(v)) return { name: 'Bagażnik duży', sub: '' };
        if (r3 && /2\s*baga/.test(v)) return { name: '3 rzędy + duży bagażnik i mały bagażnik', sub: 'Duży + mały bagażnik' };
        if (p && t && r3 && b) return { name: /du[żz]y/.test(v) ? '3 rzędy + duży bagażnik' : (/ma[łl]y/.test(v) ? '3 rzędy + mały bagażnik' : '3 rzędy + bagażnik'), sub: '' };
        if (p && t && r3) return { name: '3 rzędy', sub: 'Bez maty bagażnika' };
        if (p && t && b) return { name: /du[żz]y/.test(v) ? 'Przód + tył + duży bagażnik' : 'Przód + tył + bagażnik', sub: '4 dywaniki + mata bagażnika' };
        if (p && t) return { name: 'Przód + tył', sub: '4 dywaniki' };
        if (p && b && !t) return { name: 'Przód + bagażnik', sub: '2 dywaniki + mata bagażnika' };
        if (b && !p && !t) return { name: 'Mata do bagażnika', sub: 'Sam bagażnik' };
        if (k) return { name: 'Dywanik kierowcy', sub: '1 szt' };
        if (p && !t) return { name: 'Dywaniki przód', sub: '2 szt' };
        if (t && !p) return { name: 'Dywaniki tył', sub: 'Listwa tylna' };
        return { name: val, sub: '' };
      }
      function currentBodyType() {
        var raw = (product.getAttribute('data-type') || '').toLowerCase().trim();
        if (['bus','bus_solid','van_duzy','van_duzy_solid','van_duzy_separate','van_duzy_solid_2_row','van_duzy_separate_2_row','minivan','minivan_mini','pickup','pickup2kabina','van_maly','tractor','camper','2os','tir','electro','electro_7os'].indexOf(raw) > -1) return raw;
        var picked = product.querySelector('[data-dropdown="year"] input[name="properties[Typ nadwozia]"]:checked');
        /* Zamówienie indywidualne (kafelki z data-evm-np-body): obrazki zestawów ustawia assets/evm-np-indyw.js pod rodzaj auta
           i liczbę miejsc; klucz spoza setImages sprawia, że applySetImages niczego tu nie nadpisuje. */
        if (picked && picked.hasAttribute('data-evm-np-body')) return 'np-indywidualne';
        if (picked) raw = (picked.getAttribute('data-body-type') || picked.value || raw).toLowerCase();
        if (raw.indexOf('7os') > -1) return '7os';
        return '5os';
      }
      var setImgBase = evmAssetBase();
      var setImages = {
        '5os': {
          kierowca: 'evm-set-5os-kierowca.svg',
          front: 'evm-set-5os-front-row.svg',
          rear: 'evm-set-5os-rear-row.svg',
          frontRear: 'evm-set-5os-front-rear.svg',
          trunk: 'evm-set-5os-trunk.svg',
          frontTrunk: 'evm-set-5os-front-trunk.svg',
          frontRearTrunk: 'evm-set-5os-front-rear-trunk.svg'
        },
        '7os': {
          front: 'evm-set-7os-front-row.svg',
          rear: 'evm-set-7os-second-row.svg',
          frontRear: 'evm-set-7os-front-second.svg',
          rows123: 'evm-set-7os-front-second-third.svg',
          trunk: 'evm-set-7os-large-trunk.svg',
          frontRearTrunk: 'evm-set-7os-front-second-large-trunk.svg',
          rows123Trunk: 'evm-set-7os-all-rows-trunk.svg',
          rows123LargeTrunk: 'evm-set-7os-all-rows-large-trunk-v2.svg',
          rows123TwoTrunks: 'evm-set-7os-all-rows-two-trunks-v4.svg'
        },
        bus: { kierowca:'evm-set-box-kierowca-razdz.svg', '1rz':'evm-set-box-1rz-razdz.svg', '2rz':'evm-set-box-2rz-razdz.svg', '3rz':'evm-set-box-3rz-razdz.svg', '3rzDuzyBag':'evm-set-box-3rz-duzybag-razdz.svg', '3rzMalyBag':'evm-set-box-3rz-malybag-razdz.svg', '2rzBag':'evm-set-box-2rz-bag-razdz.svg', '1rzBag':'evm-set-van-1rz-bag-razdz.svg', duzyBag:'evm-set-box-duzybag-razdz.svg', malyBag:'evm-set-box-malybag-razdz.svg' },
        bus_solid: { '1rz':'evm-set-box-1rz-celny.svg', '2rz':'evm-set-box-2rz-celny.svg', '3rz':'evm-set-box-3rz-celny.svg', '3rzDuzyBag':'evm-set-box-3rz-duzybag-celny.svg', '3rzMalyBag':'evm-set-box-3rz-malybag-celny.svg', '2rzBag':'evm-set-box-2rz-bag-celny.svg', '1rzBag':'evm-set-box-1rz-bag-celny.svg', duzyBag:'evm-set-box-duzybag-celny.svg' },
        van_duzy_separate: { kierowca:'evm-set-box-kierowca-razdz.svg', '1rz':'evm-set-box-1rz-razdz.svg', '1rzBag':'evm-set-van-1rz-bag-razdz.svg', '2rz':'evm-set-box-2rz-razdz.svg', '2rzBag':'evm-set-box-2rz-bag-razdz.svg', duzyBag:'evm-set-van-duzybag.svg' },
        van_duzy_solid: { '1rz':'evm-set-box-1rz-celny.svg', '1rzBag':'evm-set-box-1rz-bag-celny.svg', '2rz':'evm-set-box-2rz-celny.svg', '2rzBag':'evm-set-box-2rz-bag-celny.svg', duzyBag:'evm-set-box-duzybag-celny.svg' }
      };
      setImages.van_duzy_separate_2_row = setImages.van_duzy_separate;
      setImages.van_duzy_solid_2_row = setImages.van_duzy_solid;
      setImages.van_duzy = setImages.van_duzy_separate;
      setImages.minivan = { kierowca:'evm-set-minivan-kierowca.svg', przod:'evm-set-minivan-przod.svg', '2rz':'evm-set-minivan-2rz.svg', '3rz':'evm-set-minivan-3rz.svg', malybag:'evm-set-minivan-malybag.svg', duzybag:'evm-set-minivan-duzybag.svg', '3rz-malybag':'evm-set-minivan-3rz-malybag.svg', '3rz-duzybag':'evm-set-minivan-3rz-duzybag.svg', '3rz-2bag':'evm-set-minivan-3rz-2bag-v2.svg' };
      setImages.minivan_mini = setImages.minivan;
      setImages.pickup = { kierowca:'evm-set-pickup-kierowca-v2.svg', przod:'evm-set-pickup-przod.svg', tyl:'evm-set-pickup-tyl.svg', przodtyl:'evm-set-pickup-przodtyl.svg', bagaznik:'evm-set-pickup-bagaznik.svg', 'przod-bagaznik':'evm-set-pickup-przod-bagaznik.svg', 'przodtyl-bagaznik':'evm-set-pickup-przodtyl-bagaznik.svg' };
      setImages.pickup2kabina = setImages.pickup;
      setImages.van_maly = { kierowca:'evm-set-van_maly-kierowca.svg', przod:'evm-set-van_maly-przod.svg', bagaznik:'evm-set-van_maly-bagaznik.svg', 'przod-bagaznik':'evm-set-van_maly-przod-bagaznik.svg' };
      setImages.tractor = { '1rz':'evm-set-tractor-1rz.svg' };
      setImages.camper = { '1rz':'evm-set-box-1rz-celny.svg' };
      setImages['2os'] = { kierowca:'evm-set-5os-kierowca.svg', front:'evm-set-5os-front-row.svg', rear:'evm-set-5os-rear-row.svg', frontRear:'evm-set-5os-front-rear.svg', trunk:'evm-set-5os-trunk.svg', frontTrunk:'evm-set-2os-przod-bagaznik.svg', frontRearTrunk:'evm-set-5os-front-rear-trunk.svg' };
      setImages['7os'].kierowca = 'evm-set-7os-kierowca.svg';
      setImages.electro_7os = {}; for (var _ek in setImages['7os']) { setImages.electro_7os[_ek] = setImages['7os'][_ek]; } setImages.electro_7os['caleauto-malybag'] = 'evm-set-electro_7os-caleauto-malybag.svg'; setImages.electro_7os['caleauto-duzybag'] = 'evm-set-electro_7os-caleauto-duzybag.svg';
      setImages.tir = { kierowca:'evm-set-tir-kierowca.svg', 'bez-tunelu':'evm-set-tir-bez-tunelu.svg', 'z-tunelem':'evm-set-tir-z-tunelem.svg' };
      setImages.electro = { kierowca:'evm-set-5os-kierowca.svg', front:'evm-set-5os-front-row.svg', rear:'evm-set-5os-rear-row.svg', frontRear:'evm-set-5os-front-rear.svg', trunk:'evm-set-5os-trunk.svg', frontTrunk:'evm-set-5os-front-trunk.svg', frontRearTrunk:'evm-set-5os-front-rear-trunk.svg', frunk3:'evm-set-electro_7os-caleauto-duzybag.svg' };
      function setImageKey(val, body) {
        var v = (val || '').toLowerCase();
        var p = /prz[oó]d|\bfront\b/.test(v);
        var t = /ty[łl]|\brear\b/.test(v);
        var b = /baga|\btrunks?\b|\bboots?\b/.test(v);
        var k = /kierowc|\bdriver/.test(v);
        var r1 = /1\s*rz[ąa]d|first row|one row|1\s*(?:row|st\s+row)/.test(v) || /kabina|\bcab\b/.test(v);
        var r2 = /2\s*rz[ęe]d|second row|two rows|2\s*(?:rows?|nd\s+row)/.test(v);
        var r3 = /3\s*r(z[ąa]d|z[ęe]dy)|third row|three rows|3\s*(?:rows?|rd\s+row)/.test(v);
        var large = /du[żz]y|\blarge\b/.test(v);
        var small = /ma[łl]y|\bsmall\b/.test(v);
        var whole = /ca[łl]e auto|whole car|entire car/.test(v);
        var twoBags = /2\s*(?:baga|trunks?|boots?)|two\s+(trunks?|boots?)/.test(v);

        if (/^(bus|van_duzy)/.test(body)) {
          if (k) return 'kierowca';
          if (r3 && b) return large ? '3rzDuzyBag' : '3rzMalyBag';
          if (r3) return '3rz';
          if (r2 && b) return '2rzBag';
          if (r2) return '2rz';
          if ((r1 || (p && !t && !/rz[ęe]d|row/.test(v))) && b) return '1rzBag';
          if (r1 || (p && !t && !/rz[ęe]d|row/.test(v))) return '1rz';
          if (b) return (large || !small) ? 'duzyBag' : 'malyBag';
          return '1rz';
        }
        if (body === 'electro_7os' && b && (whole || /wszyst|3\s*(?:baga|trunks?|boots?)|three\s+(trunks?|boots?)/.test(v))) {
          return large ? 'caleauto-duzybag' : 'caleauto-malybag';
        }
        if (/minivan/.test(body)) {
          if (k) return 'kierowca';
          if (whole && b) return '3rz-2bag';
          if (r3 && twoBags) return '3rz-2bag';
          if (r3 && b) return small ? '3rz-malybag' : '3rz-duzybag';
          if (r3) return '3rz';
          if (r2) return '2rz';
          if (b) return small ? 'malybag' : 'duzybag';
          return 'przod';
        }
        if (/pickup/.test(body)) {
          if (k) return 'kierowca';
          if (p && t && b) return 'przodtyl-bagaznik';
          if (p && t) return 'przodtyl';
          if (p && b) return 'przod-bagaznik';
          if (b && !p && !t) return 'bagaznik';
          if (t && !p) return 'tyl';
          return 'przod';
        }
        if (/van_maly/.test(body)) {
          if (k) return 'kierowca';
          if (p && b) return 'przod-bagaznik';
          if (b) return 'bagaznik';
          return 'przod';
        }
        if (/tractor|camper/.test(body)) return '1rz';
        if (body === 'tir') {
          if (k) return 'kierowca';
          if (/bez\s*tunel|without\s+tunnel/.test(v)) return 'bez-tunelu';
          if (/tunel|tunnel/.test(v)) return 'z-tunelem';
          if (r1) return 'bez-tunelu';
          return 'kierowca';
        }
        if (body === 'electro') {
          if (/3\s*(?:baga|trunks?|boots?)|three\s+(trunks?|boots?)/.test(v)) return 'frunk3';
          if (r1) return 'front';
          if (/^\s*2\s*rz[ąa]d\b|^\s*second\s+row\b/.test(v)) return 'rear';
          if (r2 && b) return 'frontRearTrunk';
          if (r2) return 'frontRear';
        }
        if (body === '7os' || body === 'electro_7os') {
          if (k) return 'kierowca';
          if (r3 && twoBags) return 'rows123TwoTrunks';
          if (p && t && r3 && b && large) return 'rows123LargeTrunk';
          if (p && t && r3 && b) return 'rows123Trunk';
          if (p && t && r3) return 'rows123';
          if (r3 && b && large) return 'rows123LargeTrunk';
          if (r3 && b) return 'rows123Trunk';
          if (r3) return 'rows123';
          if (r2) return 'frontRear';
          if (p && t && b) return 'frontRearTrunk';
          if (p && t) return 'frontRear';
          if (b) return 'trunk';
          if (t) return 'rear';
          return 'front';
        }
        if (p && t && b) return 'frontRearTrunk';
        if (p && b) return 'frontTrunk';
        if (p && t) return 'frontRear';
        if (b && !p && !t) return 'trunk';
        if (t && !p) return 'rear';
        if (k) return 'kierowca';
        if (p) return 'front';
        return 'frontRear';
      }
      function preferredSetRank(x) {
        var v = (x.inp.value || x.inp.dataset.title || '').toLowerCase();
        var isFrontRearBigTrunk = /prz[oó]d/.test(v) && /ty[łl]/.test(v) && /baga/.test(v) && /du[żz]y/.test(v) && !/3\s*r(z[ąa]d|z[ęe]dy)/.test(v);
        return isFrontRearBigTrunk ? 1 : 0;
      }
      /* 06.10.2026: nazwa, podpis i schemat kompletu tak jak na kartach zestawów — także dla listy kompletów zamówienia
         indywidualnego (assets/evm-np-indyw.js), która bierze komplety z produktu-wzoru, więc nie trzyma własnej kopii tych
         reguł. value — nazwa kompletu z katalogu (po polsku), body — custom.body_type wzoru; na stronie EN nazwa przez
         EVM_EN_CONFIG.translate (evm-en-config.js). */
      window.evmSetCard = function (value, body) {
        var nice = EVM_EN ? { name: (window.EVM_EN_CONFIG && window.EVM_EN_CONFIG.translate(value)) || value, sub: '' } : niceSet(value);
        var file = setImages[body] && setImages[body][setImageKey(value, body)];
        return { name: nice.name, sub: nice.sub, img: file ? setImgBase + file : '' };
      };
      function applySetImages() {
        var cur = currentBodyType();
        var bodies = (cur === '5os' || cur === '7os') ? ['5os', '7os'] : [cur];
        bodies.forEach(function (body) {
          if (!setImages[body]) return;
          list.forEach(function (x) {
            var key = setImageKey(x.inp.value || x.inp.dataset.title, body);
            var file = setImages[body] && setImages[body][key];
            if (!file) return;
            var url = setImgBase + file;
            var img = x.lab.querySelector('img');
            if (!img) return;
            img.setAttribute('data-image-' + body, url);
            if (body === currentBodyType()) img.setAttribute('src', url);
          });
        });
      }
      var list = [];
      setFs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        var lab = inp.closest('label') || setFs.querySelector('label[for="' + inp.id + '"]');
        if (!lab) return;
        list.push({ inp: inp, lab: lab });
        var tip = lab.querySelector('.label__tooltip');
        if (tip && !tip.querySelector('.evm-set-name')) {
          var nm = niceSet(inp.dataset.title || inp.value);
          tip.innerHTML = '<span class="evm-set-name">' + nm.name + '</span>' + (nm.sub ? '<span class="evm-set-sub">' + nm.sub + '</span>' : '');
        }
        if (!lab.querySelector('.evm-set-price')) lab.appendChild(el('span', 'evm-set-price', ''));
      });
      function discountRatioFor(catalogPrice) {
        if (catalogPrice >= 910) return 0.7;
        if (catalogPrice >= 290) return 0.8;
        return 1;
      }
      function setLabelBadge(lab, catalogPrice, nowPrice) {
        var badge = lab.querySelector('.label_badge');
        var pct = (catalogPrice > 0 && nowPrice != null && nowPrice < catalogPrice)
          ? Math.round((1 - (nowPrice / catalogPrice)) * 100)
          : 0;
        if (pct > 0) {
          if (!badge) {
            badge = el('div', 'label_badge', '');
            lab.appendChild(badge);
          }
          badge.textContent = '-' + pct + '%';
          badge.removeAttribute('hidden');
          badge.style.removeProperty('display');
        } else if (badge) {
          badge.remove();
        }
      }
      function syncGalDiscount() {
        var disc = document.querySelector('.evm-gal-disc');
        if (!disc) return;
        var parts = evmSelectedSetPriceParts();
        if (parts.old && parts.now && parts.old > parts.now) {
          var pct = Math.round((1 - (parts.now / parts.old)) * 100);
          disc.textContent = '−' + pct + '%';
          disc.hidden = false;
          disc.style.removeProperty('display');
        } else {
          disc.textContent = '';
          disc.hidden = true;
        }
      }
      function recompute() {
        list.forEach(function (x) {
          var pr = priceFor(x.inp.value); x.pr = pr;
          var pe = x.lab.querySelector('.evm-set-price');
          if (!pe) return;
          if (pr == null) {
            pe.innerHTML = '';
            setLabelBadge(x.lab, 0, null);
            return;
          }
          var ratio = discountRatioFor(pr);
          var now = Math.round(pr * ratio);
          pe.innerHTML = '<b>' + now + ' zł</b>' + (ratio < 1 ? '<s>' + Math.round(pr) + ' zł</s>' : '');
          setLabelBadge(x.lab, pr, now);
        });
        syncGalDiscount();
        evmRenderMainPrice();
      }
      recompute();
      applySetImages();
      var maxX = list.slice().sort(function (a, b) { return preferredSetRank(b) - preferredSetRank(a) || (b.pr || 0) - (a.pr || 0); })[0];
      if (maxX && !maxX.lab.querySelector('.evm-bestseller')) {
        maxX.lab.insertBefore(el('span', 'evm-bestseller', 'Najczęściej wybierany'), maxX.lab.firstChild);
      }
      list.slice().sort(function (a, b) { return preferredSetRank(b) - preferredSetRank(a) || (b.pr || 0) - (a.pr || 0); })
        .forEach(function (x) { setFs.appendChild(x.inp); setFs.appendChild(x.lab); });
      function pickDefaultDriverMat() {
        if (/[?&]variant=/.test(location.search)) return;
        var wantedType = typeFs && Array.prototype.slice.call(typeFs.querySelectorAll('input[type="radio"]')).find(function (inp) {
          return /3d\s+bez\s+rant/i.test(inp.value || inp.dataset.title || '');
        });
        var wantedSet = list.find(function (x) {
          return /kierowc/i.test(x.inp.value || x.inp.dataset.title || '');
        });
        if (wantedType && !wantedType.checked) {
          wantedType.checked = true;
          wantedType.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (wantedSet && !wantedSet.inp.checked) {
          wantedSet.inp.checked = true;
          wantedSet.inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      pickDefaultDriverMat();
      setTimeout(pickDefaultDriverMat, 500);
      if (typeFs) typeFs.addEventListener('change', function () { setTimeout(function () { recompute(); applySetImages(); }, 20); });
      setFs.addEventListener('change', function () { setTimeout(function () { recompute(); applySetImages(); }, 20); });
      document.addEventListener('change', function (e) {
        if (e.target && e.target.matches('[data-dropdown="year"] input[name="properties[Typ nadwozia]"]')) setTimeout(applySetImages, 30);
      }, true);
      document.addEventListener('evamats:discount-updated', function () { setTimeout(function () { recompute(); applySetImages(); }, 40); });
      [400, 1200, 2600].forEach(function (d) { setTimeout(function () { recompute(); applySetImages(); }, d); });
    })();

    /* 8f. ATC + Wstecz na karcie podsumowania */
    (function () {
      var realSubmit = product.querySelector('.product-form__submit');
      var foot = summary.querySelector('.evm-sum-foot');
      var back = summary.querySelector('.evm-sum-back');
      var atc = summary.querySelector('.evm-sum-atc');
      if (!foot) {
        foot = el('div', 'evm-sum-foot');
        back = el('button', 'evm-back evm-sum-back', ICONS.chev + ' ' + tr('Wstecz', 'Back')); back.type = 'button';
        atc = el('button', 'evm-sum-atc', tr('Dodaj do koszyka', 'Add to cart')); atc.type = 'button';
        foot.appendChild(back); foot.appendChild(atc);
        summary.appendChild(foot);
      }
      if (back) {
        back.addEventListener('click', function () { clickTitle(wrappers[wrappers.length - 1]); scrollToConfig(); });
      }
      if (atc) {
        atc.addEventListener('click', function () {
          if (evmAtcBusy()) return;
          if (realSubmit) realSubmit.click();
          syncSummaryAtcLabel();
        });
      }
    })();

    /* 8i. Cross-sell tylko dla config mobile — boot when the block is near view (native grid stays until then). */
    (function () {
      var xsellRoot = document.querySelector('.related-products-custom, [class*="related-products-custom"], [class*="related_products_custom"]');
      if (!xsellRoot) return;
      function bootXsell() {
        var xsell = document.querySelector('.related-products-custom, [class*="related-products-custom"], [class*="related_products_custom"]');
        if (!xsell || xsell.dataset.evmXsell) return;
        var grid = xsell.querySelector('ul.product-grid, ul.related-products__list, ul.grid.product-grid, ul.grid');
        if (!grid) return;
        xsell.dataset.evmXsell = '1';

        var head = xsell.querySelector('h2, .related-products__heading');
        if (head && !head.querySelector('.evm-xhead__ico')) {
          head.classList.add('evm-xhead');
          head.insertBefore(el('span', 'evm-xhead__ico', ICONS.box), head.firstChild);
        }

        var cats = [
          { n: 'Popularne', h: 'cro-popularne' },
          { n: 'Ochrona', h: 'cro-ochrona' },
          { n: 'Organizery', h: 'cro-organizery' }
        ];
        var nativeHTML = grid.innerHTML;
        function readNativeProducts() {
          grid.innerHTML = nativeHTML;
          function compactPrice(txt) {
            var s = String(txt || '').replace(/\s+/g, ' ').trim();
            var od = /\bOd\b/i.test(s);
            var matches = s.match(/\d+(?:[,.]\d{2})?\s*zł/g) || [];
            if (!matches.length) return s;
            return (od ? 'Od ' : '') + matches[matches.length - 1];
          }
          return Array.prototype.slice.call(grid.querySelectorAll('li.grid__item, li')).map(function (li) {
            var a = li.querySelector('a[href*="/products/"]');
            var img = li.querySelector('img');
            var title = (li.querySelector('.card__heading, .full-unstyled-link, a[href*="/products/"]') || a || li).textContent || '';
            var price = (li.querySelector('.price, .price-item, [class*="price"]') || {}).textContent || '';
            var variantInput = li.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"][value]');
            return {
              href: a ? a.getAttribute('href') : '',
              title: title.replace(/\s+/g, ' ').trim(),
              image: img ? (img.currentSrc || img.src || img.getAttribute('src')) : '',
              priceText: compactPrice(price),
              variantId: variantInput ? variantInput.value : ''
            };
          }).filter(function (p) { return p.href && p.title; });
        }
        var nativeProducts = readNativeProducts();
        var cache = {};
        var active = 0;
        var expanded = false;
        var more = el('button', 'evm-xmore', 'Pokaż więcej ' + ICONS.chev);
        more.type = 'button';
        more.addEventListener('click', function () {
          expanded = !expanded;
          select(active, true);
        });
        var bar = el('div', 'evm-xcats');

        function esc(s) {
          return String(s || '').replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
          });
        }
        function money(v) { var n = parseFloat(v); return isNaN(n) ? '' : (Math.round(n) + ' zł'); }
        function syncMore(total) {
          if (total > 4) {
            more.innerHTML = (expanded ? 'Pokaż mniej' : 'Pokaż więcej') + ' ' + ICONS.chev;
            if (more.parentNode !== xsell) xsell.appendChild(more);
          } else if (more.parentNode) {
            more.parentNode.removeChild(more);
          }
        }
        function restoreNative() {
          render(nativeProducts);
        }
        function render(products) {
          grid.classList.remove('evm-xnative');
          grid.classList.add('evm-xgrid');
          if (!products || !products.length) {
            grid.innerHTML = '<li class="evm-xempty">Brak produktów w tej kategorii.</li>';
            syncMore(0);
            return;
          }
          grid.innerHTML = products.slice(0, expanded ? products.length : 4).map(function (p) {
            var im = p.image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || p.featured_image || '';
            var pr = p.priceText || money((p.variants && p.variants[0] && p.variants[0].price) || p.price || '');
            var href = p.href || ('/products/' + (p.handle || ''));
            var variantId = p.variantId || (p.variants && p.variants[0] && p.variants[0].id) || '';
            var btnHref = variantId ? ('/cart/add?id=' + encodeURIComponent(variantId) + '&quantity=1') : href;
            return '<li class="grid__item evm-xli"><article class="evm-xcard">' +
              '<a class="evm-xcard__link" href="' + esc(href) + '">' +
              '<span class="evm-xcard__img">' + (im ? '<img loading="lazy" alt="" src="' + esc(im) + '">' : '') + '</span>' +
              '<span class="evm-xcard__body"><span class="evm-xcard__t">' + esc(p.title) + '</span>' +
              '<span class="evm-xcard__p">' + esc(pr) + '</span></span></a>' +
              '<a class="evm-xcard__btn" href="' + esc(btnHref) + '">DODAJ DO KOSZYKA</a></article></li>';
          }).join('');
          syncMore(products.length);
        }
        function select(i, keepExpanded) {
          active = i;
          if (!keepExpanded) expanded = false;
          Array.prototype.forEach.call(bar.children, function (b, bi) { b.classList.toggle('on', bi === i); });
          var c = cats[i];
          if (!c.h) { restoreNative(); return; }
          if (cache[c.h]) { render(cache[c.h]); return; }
          fetch('/collections/' + c.h + '/products.json?limit=12')
            .then(function (r) { return r.json(); })
            .then(function (d) { cache[c.h] = d.products || []; render(cache[c.h]); })
            .catch(restoreNative);
        }
        cats.forEach(function (c, i) {
          var b = el('button', 'evm-xcat' + (i === 0 ? ' on' : ''), c.n);
          b.type = 'button';
          b.addEventListener('click', function () { select(i); });
          bar.appendChild(b);
        });
        if (head && head.parentNode) head.parentNode.insertBefore(bar, head.nextSibling);
        else xsell.insertBefore(bar, xsell.firstChild);
        select(0);
      }
      function scheduleBoot() {
        if (xsellRoot.dataset.evmXsellBoot) return;
        xsellRoot.dataset.evmXsellBoot = '1';
        bootXsell();
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              io.disconnect();
              scheduleBoot();
              return;
            }
          }
        }, { rootMargin: '240px 0px' });
        io.observe(xsellRoot);
      } else {
        setTimeout(scheduleBoot, 250);
      }
    })();

    /* 8j. Krok 1 (rok): fill vehicle name + show hint when year chosen */
    var yearHint = product.querySelector('.evm-year-hint');
    if (isIndividualPrepaymentProduct && yearHint) {
      yearHint.parentNode.removeChild(yearHint);
      yearHint = null;
    }
    var vehicleHintEl = product.querySelector('.evm-year-hint__vehicle');
    if (vehicleHintEl) vehicleHintEl.textContent = vehicle;
    function syncYearHint() {
      if (!yearHint) return;
      var on = yearChosen();
      yearHint.classList.toggle('is-on', on);
      if (on) yearHint.removeAttribute('hidden');
      else yearHint.setAttribute('hidden', '');
    }

    /* 8L. „Uwagi do zamówienia" → do kroku Akcesoria (ostatni krok) */
    (function () {
      var uw = document.getElementById('uwagi-do-zamowienia');
      var uwField = uw ? uw.closest('.line-item-property__field, p') : null;
      var extras = wrappers[wrappers.length - 1];
      var inner = extras ? extras.querySelector('.product__dropdown_inner') : null;
      if (uwField && inner && !inner.contains(uwField)) {
        uwField.classList.add('evm-uwagi');
        var nav = inner.querySelector('.evm-nav-row');
        if (nav) inner.insertBefore(uwField, nav); else inner.appendChild(uwField);
      }
    })();

    /* 8m. GALERIA — wire Liquid badges + arrows */
    (function () {
      var wrap = product.querySelector('.product-media-gallery-wr') || product.querySelector('.product__media-wrapper');
      if (!wrap || wrap.dataset.evmGal) return;
      wrap.dataset.evmGal = '1';
      wrap.style.position = 'relative';
      var prev = wrap.querySelector('.evm-nav-prev');
      var next = wrap.querySelector('.evm-nav-next');
      if (!prev || !next) return;
      if (prev.parentElement !== wrap) wrap.appendChild(prev);
      if (next.parentElement !== wrap) wrap.appendChild(next);

      function activeGallery() {
        return wrap.querySelector('media-gallery.active') || wrap.querySelector('media-gallery');
      }
      function mediaItems() {
        var gal = activeGallery();
        return gal ? Array.prototype.slice.call(gal.querySelectorAll('.product__media-list .product__media-item')) : [];
      }
      function activeIndex() {
        var items = mediaItems();
        var idx = items.findIndex(function (item) { return item.classList.contains('is-active'); });
        return idx < 0 ? 0 : idx;
      }
      function setBtnState(btn, disabled) {
        if (!btn) return;
        btn.toggleAttribute('disabled', !!disabled);
        btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }
      function syncMainNav() {
        var items = mediaItems();
        var idx = activeIndex();
        var atStart = idx <= 0;
        var atEnd = !items.length || idx >= items.length - 1;
        setBtnState(prev, atStart);
        setBtnState(next, atEnd);
      }
      function syncThumbNav() {
        var gal = activeGallery();
        if (!gal) return;
        if (typeof gal.updateThumbnailNavButtons === 'function') {
          try { gal.updateThumbnailNavButtons(); } catch (e) {}
        }
        var thumbs = gal.querySelector('.thumbnail-slider') || gal.querySelector('[id^="GalleryThumbnails"]');
        if (!thumbs) return;
        var tPrev = thumbs.querySelector('button[name="previous"]');
        var tNext = thumbs.querySelector('button[name="next"]');
        var items = mediaItems();
        var idx = activeIndex();
        setBtnState(tPrev, idx <= 0);
        setBtnState(tNext, !items.length || idx >= items.length - 1);
      }
      function syncAllNav() {
        syncMainNav();
        syncThumbNav();
      }
      function placeNav() {
        if (!prev || !next) return;
        var gal = activeGallery();
        var media = gal && (
          gal.querySelector('.product__media-item.is-active .product__media') ||
          gal.querySelector('.product__media')
        );
        if (!media) return;
        var wr = wrap.getBoundingClientRect();
        var mr = media.getBoundingClientRect();
        if (wr.height < 1 || mr.height < 1) return;
        var mid = (mr.top + mr.bottom) / 2 - wr.top;
        prev.style.top = mid + 'px';
        next.style.top = mid + 'px';
        prev.style.transform = 'translateY(-50%)';
        next.style.transform = 'translateY(-50%)';
      }
      function go(dir) {
        var items = mediaItems();
        var idx = activeIndex() + dir;
        if (idx < 0 || idx >= items.length) {
          syncAllNav();
          return;
        }
        var gal = activeGallery();
        var mediaId = items[idx].getAttribute('data-media-id');
        if (gal && typeof gal.setActiveMedia === 'function' && mediaId) {
          gal.setActiveMedia(mediaId, false);
        } else {
          var thumbBtn = gal && gal.querySelector('[data-target="' + mediaId + '"] button');
          if (thumbBtn) thumbBtn.click();
          else {
            items.forEach(function (item, i) { item.classList.toggle('is-active', i === idx); });
          }
        }
        window.setTimeout(function () {
          placeNav();
          syncAllNav();
        }, 40);
      }

      prev.addEventListener('click', function (e) { e.preventDefault(); if (prev.disabled) return; go(-1); });
      next.addEventListener('click', function (e) { e.preventDefault(); if (next.disabled) return; go(1); });

      wrap.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.thumbnail-list .thumbnail, .thumbnail-list button')) {
          window.setTimeout(function () { placeNav(); syncAllNav(); }, 50);
        }
      });

      var gal = activeGallery();
      if (gal) {
        var viewer = gal.querySelector('[id^="GalleryViewer"]');
        if (viewer) viewer.addEventListener('slideChanged', function () {
          placeNav();
          syncAllNav();
        });
        var thumbSlider = gal.querySelector('.thumbnail-slider');
        var thumbList = gal.querySelector('.thumbnail-list');
        /* Dawn slider-component rewrites [disabled] on scroll — re-assert first/last media state */
        function reassert() { window.setTimeout(syncAllNav, 0); }
        if (thumbList) thumbList.addEventListener('scroll', reassert, { passive: true });
        if (thumbSlider) {
          thumbSlider.querySelectorAll('.slider-button').forEach(function (b) {
            b.addEventListener('click', function () { window.setTimeout(function () { placeNav(); syncAllNav(); }, 60); });
          });
        }
      }

      placeNav();
      syncAllNav();
      window.addEventListener('resize', function () { placeNav(); syncAllNav(); });
      if (window.ResizeObserver) {
        try { new ResizeObserver(function () { placeNav(); syncAllNav(); }).observe(wrap); } catch (e) {}
      }
      [120, 400, 1000].forEach(function (ms) { setTimeout(function () { placeNav(); syncAllNav(); }, ms); });
    })();

    /* 8j2. Cena główna — same path as evmRenderMainPrice (already wired above) */
    function syncDmixerMainPrice() {
      evmRenderMainPrice();
    }
    function safeSyncMainPrice() {
      try { syncDmixerMainPrice(); } catch (e) { }
    }

    /* 8k. ukryj natywne „wróć do koszyka" na mobilce — do NOT rescan whole DOM on every mutation */
    function hideCartReturn() {
      var roots = document.querySelectorAll(
        '.cart-notification, .cart__toast, [class*="cart-return"], [class*="back-to-cart"], #cart-notification'
      );
      if (!roots.length) return;
      Array.prototype.forEach.call(roots, function (root) {
        Array.prototype.slice.call(root.querySelectorAll('a,button,div,span')).forEach(function (n) {
          if (n.children.length > 1) return;
          var t = (n.textContent || '').trim().toLowerCase();
          if (t && t.length < 40 && (/wróć do koszyk|powrót do koszyk|wroc do koszyk|kontynuuj zakup/.test(t))) {
            var box = n.closest('.cart-notification, .cart__toast, [class*="cart-return"], [class*="back-to-cart"]') || n;
            box.style.setProperty('display', 'none', 'important');
          }
        });
      });
    }
    hideCartReturn();
    var hideCartT = 0;
    new MutationObserver(function () {
      clearTimeout(hideCartT);
      hideCartT = setTimeout(hideCartReturn, 300);
    }).observe(document.body, { childList: true, subtree: false });

    /* 8n. cfg-card already in Liquid — only pull later steps (upsell) into it */
    (function () {
      var card = product.querySelector('.evm-cfg-card');
      if (!card) {
        if (!progress || !progress.parentNode) return;
        card = el('div', 'evm-cfg-card');
        progress.parentNode.insertBefore(card, progress);
      }
      if (progress && progress.parentNode !== card) card.appendChild(progress);
      wrappers.forEach(function (w) {
        if (w.parentNode !== card) card.appendChild(w);
      });
      if (summary && summary.parentNode !== card) card.appendChild(summary);
    })();

    /* 8g. preview — handled by product-config.js (mobile popup / desktop gallery) */

    /* 8h. dodawanie do koszyka (ukryty natywny submit) */
    function addToCart() {
      var sub = product.querySelector('.product-form__submit');
      if (sub) { sub.click(); return; }
      var f = product.querySelector('form[action*="/cart/add"], product-form form');
      if (f) { f.requestSubmit ? f.requestSubmit() : f.submit(); }
    }
    /* Stan „dodawanie trwa" bierzemy z natywnego submitu (aria-disabled ustawia product-form.js)
       i odbijamy na obu widocznych przyciskach: sticky (mobile) i w podsumowaniu (desktop/mobile). */
    (function () {
      var sub = product.querySelector('product-form button[name="add"], .product-form__submit');
      if (!sub || !window.MutationObserver) return;
      new MutationObserver(function () {
        try { syncSummaryAtcLabel(); } catch (e) {}
        try { syncBuybar(); } catch (e) {}
      }).observe(sub, { attributes: true, attributeFilter: ['aria-disabled', 'class'] });
    })();

    /* ---------- 7. synchronizacja ---------- */
    var syncAllT = 0;
    var syncing = false;
    function syncAllNow() {
      if (syncing) return;
      syncing = true;
      try {
        syncBuybar();
        syncShip();
        syncSummary();
        syncProgress();
        syncPreview();
        syncDmixerMainPrice();
        syncYearHint();
        wizardGuard();
      } finally {
        syncing = false;
      }
    }
    function syncAll() {
      clearTimeout(syncAllT);
      syncAllT = setTimeout(syncAllNow, 80);
    }
    product.addEventListener('change', function (e) {
      // Heel/extras option toggles only need price/summary — skip wizardGuard thrash when possible
      if (e.target && (e.target.name === 'product__upsell' || e.target.name === 'product__extras')) {
        clearTimeout(syncAllT);
        syncAllT = setTimeout(function () {
          if (syncing) return;
          syncing = true;
          try {
            refreshConfigTotalPrice();
            syncBuybar();
            syncShip();
            syncSummary();
            syncDmixerMainPrice();
          } finally { syncing = false; }
        }, 80);
        return;
      }
      syncAll();
    }, true);
    var mo = new MutationObserver(function () { syncAll(); });
    wrappers.forEach(function (w) { mo.observe(w, { attributes: true, attributeFilter: ['class'] }); });
    // Do NOT observe priceSrc for syncAll — updatePrices↔syncSummary caused a permanent rebuild loop on .evm-summary__rows
    if (priceSrc) {
      var priceSrcT = 0;
      new MutationObserver(function () {
        clearTimeout(priceSrcT);
        priceSrcT = setTimeout(function () {
          if (bbPrice) {
            var cur = priceSrc.textContent.trim();
            if (bbPrice.textContent !== cur) bbPrice.textContent = cur;
          }
          syncSummaryAtcLabel();
          syncShip();
        }, 60);
      }).observe(priceSrc, { childList: true, characterData: true, subtree: true });
    }
    syncAllNow();
    setTimeout(syncAll, 600);
    document.addEventListener('evamats:discount-updated', function () { setTimeout(syncDmixerMainPrice, 50); });
    setTimeout(setTabsTop, 600);
  });
})();
